const ENDPOINTS = [
  {
    id: 'corprate/profiles',
    method: 'GET',
    url: `/profiles/AAPL`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

profile = client.profiles.profile('AAPL')
print(profile)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const profile = await client.profiles.profile('AAPL');
console.log(profile);`,
      cURL: `curl -X GET "https://api.axionquant.com/profiles/AAPL/" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `{
  "address1": "One Apple Park Way",
  "city": "Cupertino",
  "state": "CA",
  "zip": "95014",
  "country": "United States",
  "phone": "(408) 996-1010",
  "website": "https://www.apple.com",
  "industry": "Consumer Electronics",
  "industryKey": "consumer-electronics",
  "industryDisp": "Consumer Electronics",
  "sector": "Technology",
  "sectorKey": "technology",
  "sectorDisp": "Technology",
  "longBusinessSummary": "Apple Inc. designs, manufactures, and markets smartphones, personal computers, tablets, wearables, and accessories worldwide. The company offers iPhone, a line of smartphones; Mac, a line of personal computers; iPad, a line of multi-purpose tablets; and wearables, home, and accessories comprising AirPods, Apple Vision Pro, Apple TV, Apple Watch, Beats products, and HomePod, as well as Apple branded and third-party accessories. It also provides AppleCare support and cloud services; and operates various platforms, including the App Store that allow customers to discover and download applications and digital content, such as books, music, video, games, and podcasts, as well as advertising services include third-party licensing arrangements and its own advertising platforms. In addition, the company offers various subscription-based services, such as Apple Arcade, a game subscription service; Apple Fitness+, a personalized fitness service; Apple Music, which offers users a curated listening experience with on-demand radio stations; Apple News+, a subscription news and magazine service; Apple TV, which offers exclusive original content and live sports; Apple Card, a co-branded credit card; and Apple Pay, a cashless payment service, as well as licenses its intellectual property. The company serves consumers, and small and mid-sized businesses; and the education, enterprise, and government markets. It distributes third-party applications for its products through the App Store. The company also sells its products through its retail and online stores, and direct sales force; and third-party cellular network carriers and resellers. The company was formerly known as Apple Computer, Inc. and changed its name to Apple Inc. in January 2007. Apple Inc. was founded in 1976 and is headquartered in Cupertino, California.",
  "fullTimeEmployees": 166000,
  "companyOfficers": [
    {
      "name": "Mr. Timothy D. Cook",
      "age": 63,
      "title": "CEO & Director",
      "yearBorn": 1961,
      "fiscalYear": 2024,
      "totalPay": 16520856,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Ms. Katherine L. Adams",
      "age": 60,
      "title": "Senior VP & General Counsel",
      "yearBorn": 1964,
      "fiscalYear": 2024,
      "totalPay": 5022182,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Ms. Deirdre  O'Brien",
      "age": 57,
      "title": "Senior Vice President of Retail & People",
      "yearBorn": 1967,
      "fiscalYear": 2024,
      "totalPay": 5022182,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Mr. Kevan  Parekh",
      "age": 52,
      "title": "Senior VP & CFO",
      "yearBorn": 1972,
      "fiscalYear": 2024,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Mr. Sabih  Khan",
      "title": "Chief Operating Officer",
      "fiscalYear": 2024,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Mr. Chris  Kondo",
      "title": "Senior Director of Corporate Accounting",
      "fiscalYear": 2024,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Suhasini  Chandramouli",
      "title": "Director of Investor Relations",
      "fiscalYear": 2024,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Ms. Kristin Huguet Quayle",
      "title": "Vice President of Worldwide Communications",
      "fiscalYear": 2024,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Mr. Greg  Joswiak",
      "title": "Senior Vice President of Worldwide Marketing",
      "fiscalYear": 2024,
      "exercisedValue": 0,
      "unexercisedValue": 0
    },
    {
      "name": "Mr. Adrian  Perica",
      "age": 50,
      "title": "Vice President of Corporate Development",
      "yearBorn": 1974,
      "fiscalYear": 2024,
      "exercisedValue": 0,
      "unexercisedValue": 0
    }
  ],
  "auditRisk": 7,
  "boardRisk": 1,
  "compensationRisk": 3,
  "shareHolderRightsRisk": 1,
  "overallRisk": 1,
  "governanceEpochDate": "2025-12-01T00:00:00.000Z",
  "compensationAsOfEpochDate": "2024-12-31T00:00:00.000Z",
  "irWebsite": "http://investor.apple.com/",
  "executiveTeam": []
}`,
  },

  {
    id: 'stocks/prices',
    method: 'GET',
    url: `/stocks/TSLA/prices`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

prices = client.stocks.prices('TSLA',
  frame='daily',
  from_date='2025-12-01',
  to_date='2025-12-19'
)
print(prices)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const prices = await client.stocks.prices('TSLA', {
  frame: 'daily',
  from: '2025-12-01',
  to: '2025-12-19'
});
console.log(prices);`,
      cURL: `curl -X GET "https://api.axionquant.com/stocks/TSLA/prices?frame=daily&from=2025-12-01&to=2025-12-19" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `
[
  {
    "time": "2025-12-19T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "488.120000",
    "high": "490.490000",
    "low": "474.720000",
    "close": "481.200000",
    "volume": "103305400"
  },
  {
    "time": "2025-12-18T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "478.160000",
    "high": "490.860000",
    "low": "473.120000",
    "close": "483.370000",
    "volume": "95168400"
  },
  {
    "time": "2025-12-17T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "488.220000",
    "high": "495.280000",
    "low": "466.200000",
    "close": "467.260000",
    "volume": "106490400"
  },
  {
    "time": "2025-12-16T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "472.210000",
    "high": "491.500000",
    "low": "465.830000",
    "close": "489.880000",
    "volume": "107608100"
  },
  {
    "time": "2025-12-15T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "469.440000",
    "high": "481.770000",
    "low": "467.660000",
    "close": "475.310000",
    "volume": "114542200"
  },
  {
    "time": "2025-12-12T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "448.090000",
    "high": "463.010000",
    "low": "441.670000",
    "close": "458.960000",
    "volume": "95656700"
  },
  {
    "time": "2025-12-11T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "448.950000",
    "high": "449.270000",
    "low": "440.330000",
    "close": "446.890000",
    "volume": "55979500"
  },
  {
    "time": "2025-12-10T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "446.070000",
    "high": "456.880000",
    "low": "443.610000",
    "close": "451.450000",
    "volume": "63257500"
  },
  {
    "time": "2025-12-09T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "437.540000",
    "high": "452.390000",
    "low": "435.700000",
    "close": "445.170000",
    "volume": "62367400"
  },
  {
    "time": "2025-12-08T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "447.450000",
    "high": "449.750000",
    "low": "435.250000",
    "close": "439.580000",
    "volume": "69165800"
  },
  {
    "time": "2025-12-05T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "453.030000",
    "high": "458.870000",
    "low": "451.660000",
    "close": "455.000000",
    "volume": "56427500"
  },
  {
    "time": "2025-12-04T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "449.940000",
    "high": "454.630000",
    "low": "445.390000",
    "close": "454.530000",
    "volume": "71906500"
  },
  {
    "time": "2025-12-03T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "432.100000",
    "high": "447.920000",
    "low": "431.110000",
    "close": "446.740000",
    "volume": "87483000"
  },
  {
    "time": "2025-12-02T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "430.810000",
    "high": "436.800000",
    "low": "422.120000",
    "close": "429.240000",
    "volume": "69336600"
  },
  {
    "time": "2025-12-01T00:00:00.000Z",
    "ticker": "TSLA",
    "open": "425.320000",
    "high": "433.660000",
    "low": "425.290000",
    "close": "430.140000",
    "volume": "57463600"
  }
]
`,
  },
  {
    id: 'filings/ticker',
    method: 'GET',
    url: `/filings/MSFT`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

filings = client.filings.recent('MSFT', limit=10)
print(filings)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const filings = await client.filings.recent('MSFT', {
  limit: 10
});
console.log(filings);`,
      cURL: `curl -X GET "https://api.axionquant.com/filings/MSFT?limit=10" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
  {
    "form": "SCHEDULE 13G",
    "url": "https://www.sec.gov/Archives/edgar/data/789019/000210011926000820/xslSCHEDULE_13G_X02/primary_doc.xml"
  },
    {
      "form": "10-Q",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000119312526191507/msft-20260331.htm"
    },
    {
      "form": "8-K",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000119312526191457/msft-20260429.htm"
    },
    {
      "form": "4",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000078901926000070/xslF345X06/form4.xml"
    },
    {
      "form": "SCHEDULE 13G/A",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000010290926001884/xslSCHEDULE_13G_X02/primary_doc.xml"
    },
    {
      "form": "11-K",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000119312526120090/msft-20251231.htm"
    },
    {
      "form": "4",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000078901926000066/xslF345X05/form4.xml"
    },
    {
      "form": "4",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000078901926000064/xslF345X05/form4.xml"
    },
    {
      "form": "4",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000078901926000063/xslF345X05/form4.xml"
    },
    {
      "form": "4",
      "url": "https://www.sec.gov/Archives/edgar/data/789019/000078901926000062/xslF345X05/form4.xml"
    }
]`,
  },

  // EARNINGS
  {
    id: 'earnings/ticker/history',
    method: 'GET',
    url: `/earnings/NVDA/history`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

history = client.earnings.history('NVDA')
print(history)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const history = await client.earnings.history('NVDA');
console.log(history);`,
      cURL: `curl -X GET "https://api.axionquant.com/earnings/NVDA/history" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
  {
    "epsActual": 0.89,
    "epsEstimate": 0.84562,
    "epsDifference": 0.04,
    "surprisePercent": 0.0525,
    "quarter": "2025-01-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-4q"
  },
  {
    "epsActual": 0.81,
    "epsEstimate": 0.74988,
    "epsDifference": 0.06,
    "surprisePercent": 0.0802,
    "quarter": "2025-04-30T00:00:00.000Z",
    "currency": "USD",
    "period": "-3q"
  },
  {
    "epsActual": 1.05,
    "epsEstimate": 1.00867,
    "epsDifference": 0.04,
    "surprisePercent": 0.040999997,
    "quarter": "2025-07-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-2q"
  },
  {
    "epsActual": 1.3,
    "epsEstimate": 1.2548,
    "epsDifference": 0.05,
    "surprisePercent": 0.036,
    "quarter": "2025-10-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-1q"
  }
]`,
  },

  {
    id: 'etfs/exposure',
    method: 'GET',
    url: `/etfs/AVGO/exposure`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

exposure = client.etfs.exposure('AVGO')
print(exposure)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const exposure = await client.etfs.exposure('AVGO');
console.log(exposure);`,
      cURL: `curl -X GET "https://api.axionquant.com/etfs/AVGO/exposure" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
  {
    "ticker": "IETC",
    "fundName": "iShares U.S. Tech Independence Focused ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "11.72%",
    "marketValue": "$14.98M",
    "rawAllocation": 0.1172,
    "rawMarketValue": 14980000
  },
  {
    "ticker": "TRFK",
    "fundName": "Pacer Data and Digital Revolution ETF",
    "segment": "Equity: Global Digital Economy",
    "allocation": "10.11%",
    "marketValue": "$104.77K",
    "rawAllocation": 0.1011,
    "rawMarketValue": 104770
  },
  {
    "ticker": "USD",
    "fundName": "ProShares Ultra Semiconductors",
    "segment": "Leveraged Equity: U.S. Semiconductors",
    "allocation": "8.67%",
    "marketValue": "$15.96M",
    "rawAllocation": 0.0867,
    "rawMarketValue": 15960000
  },
  {
    "ticker": "FTXL",
    "fundName": "First Trust Nasdaq Semiconductor ETF",
    "segment": "Equity: U.S. Semiconductors",
    "allocation": "8.57%",
    "marketValue": "$79.57M",
    "rawAllocation": 0.0857,
    "rawMarketValue": 79570000
  },
  {
    "ticker": "SOXX",
    "fundName": "iShares Semiconductor ETF",
    "segment": "Equity: U.S. Semiconductors",
    "allocation": "8.46%",
    "marketValue": "$620.39M",
    "rawAllocation": 0.0846,
    "rawMarketValue": 620390000
  },
  {
    "ticker": "SOXQ",
    "fundName": "Invesco PHLX Semiconductor ETF",
    "segment": "Equity: U.S. Semiconductors",
    "allocation": "8.46%",
    "marketValue": "$8.71M",
    "rawAllocation": 0.0846,
    "rawMarketValue": 8710000
  },
  {
    "ticker": "TDIV",
    "fundName": "First Trust NASDAQ Technology Dividend Index Fund",
    "segment": "Equity: Global Information Technology",
    "allocation": "8.20%",
    "marketValue": "$140.87M",
    "rawAllocation": 0.082,
    "rawMarketValue": 140870000
  },
  {
    "ticker": "SHOC",
    "fundName": "Strive U.S. Semiconductor ETF",
    "segment": "Equity: U.S. Semiconductors",
    "allocation": "7.92%",
    "marketValue": "$1.83M",
    "rawAllocation": 0.0792,
    "rawMarketValue": 1830000
  },
  {
    "ticker": "SOXL",
    "fundName": "Direxion Daily Semiconductor Bull 3X Shares",
    "segment": "Leveraged Equity: U.S. Semiconductors",
    "allocation": "7.11%",
    "marketValue": "$312.74M",
    "rawAllocation": 0.0711,
    "rawMarketValue": 312740000
  },
  {
    "ticker": "CIBR",
    "fundName": "First Trust NASDAQ Cybersecurity ETF",
    "segment": "Equity: Global Cybersecurity",
    "allocation": "6.46%",
    "marketValue": "$290.33M",
    "rawAllocation": 0.0646,
    "rawMarketValue": 290330000
  },
  {
    "ticker": "CGDV",
    "fundName": "Capital Group Dividend Value ETF",
    "segment": "Equity: U.S.  -  Total Market Value",
    "allocation": "5.70%",
    "marketValue": "$121.58M",
    "rawAllocation": 0.057,
    "rawMarketValue": 121580000
  },
  {
    "ticker": "PSI",
    "fundName": "Invesco Dynamic Semiconductors ETF",
    "segment": "Equity: U.S. Semiconductors",
    "allocation": "5.59%",
    "marketValue": "$29.32M",
    "rawAllocation": 0.0559,
    "rawMarketValue": 29320000
  },
  {
    "ticker": "SEMI",
    "fundName": "Columbia Seligman Semiconductor and Technology ETF",
    "segment": "Equity: Global Information Technology",
    "allocation": "5.44%",
    "marketValue": "$943.73K",
    "rawAllocation": 0.0544,
    "rawMarketValue": 943730
  },
  {
    "ticker": "LCLG",
    "fundName": "Logan Capital Broad Innovative Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "5.33%",
    "marketValue": "$2.54M",
    "rawAllocation": 0.0533,
    "rawMarketValue": 2540000
  },
  {
    "ticker": "SMH",
    "fundName": "VanEck Semiconductor ETF",
    "segment": "Equity: Global Semiconductors",
    "allocation": "5.00%",
    "marketValue": "$371.82M",
    "rawAllocation": 0.05,
    "rawMarketValue": 371820000
  },
  {
    "ticker": "CGUS",
    "fundName": "Capital Group Core Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "4.63%",
    "marketValue": "$39.21M",
    "rawAllocation": 0.0463,
    "rawMarketValue": 39210000
  },
  {
    "ticker": "DURA",
    "fundName": "VanEck Durable High Dividend ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "4.59%",
    "marketValue": "$4.44M",
    "rawAllocation": 0.0459,
    "rawMarketValue": 4440000
  },
  {
    "ticker": "EGIS",
    "fundName": "2ndVote Society Defended ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "4.58%",
    "marketValue": "$1.22M",
    "rawAllocation": 0.0458,
    "rawMarketValue": 1220000
  },
  {
    "ticker": "WBIL",
    "fundName": "WBI BullBear Quality 3000 ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "4.45%",
    "marketValue": "$1.82M",
    "rawAllocation": 0.0445,
    "rawMarketValue": 1820000
  },
  {
    "ticker": "HDV",
    "fundName": "iShares Core High Dividend ETF",
    "segment": "Equity: U.S.  -  High Dividend Yield",
    "allocation": "4.23%",
    "marketValue": "$447.57M",
    "rawAllocation": 0.0423,
    "rawMarketValue": 447570000
  },
  {
    "ticker": "SCHD",
    "fundName": "Schwab U.S. Dividend Equity ETF",
    "segment": "Equity: U.S.  -  High Dividend Yield",
    "allocation": "4.18%",
    "marketValue": "$1.88B",
    "rawAllocation": 0.0418,
    "rawMarketValue": 1880000000
  },
  {
    "ticker": "WBIF",
    "fundName": "WBI BullBear Value 3000 ETF",
    "segment": "Equity: Global  - Total Market Value",
    "allocation": "4.01%",
    "marketValue": "$1.45M",
    "rawAllocation": 0.0401,
    "rawMarketValue": 1450000
  },
  {
    "ticker": "UDI",
    "fundName": "USCF Dividend Income Fund",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "3.95%",
    "marketValue": "$215.85K",
    "rawAllocation": 0.0395,
    "rawMarketValue": 215850
  },
  {
    "ticker": "LYFE",
    "fundName": "2ndVote Life Neutral Plus ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "3.91%",
    "marketValue": "$722.04K",
    "rawAllocation": 0.0391,
    "rawMarketValue": 722040
  },
  {
    "ticker": "XPND",
    "fundName": "First Trust Expanded Technology ETF",
    "segment": "Equity: U.S. Broad Technology",
    "allocation": "3.75%",
    "marketValue": "$236.68K",
    "rawAllocation": 0.0375,
    "rawMarketValue": 236680
  },
  {
    "ticker": "XLK",
    "fundName": "Technology Select Sector SPDR Fund",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "3.56%",
    "marketValue": "$1.54B",
    "rawAllocation": 0.0356,
    "rawMarketValue": 1540000000
  },
  {
    "ticker": "PWB",
    "fundName": "Invesco Dynamic Large Cap Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "3.48%",
    "marketValue": "$20.74M",
    "rawAllocation": 0.0348,
    "rawMarketValue": 20740000
  },
  {
    "ticker": "NDVG",
    "fundName": "Nuveen Dividend Growth ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "3.42%",
    "marketValue": "$279.42K",
    "rawAllocation": 0.0342,
    "rawMarketValue": 279420
  },
  {
    "ticker": "QDYN",
    "fundName": "FlexShares Quality Dividend Dynamic Index Fund",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "3.37%",
    "marketValue": "$560.46K",
    "rawAllocation": 0.0337,
    "rawMarketValue": 560460
  },
  {
    "ticker": "QDF",
    "fundName": "FlexShares Quality Dividend Index Fund",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "3.31%",
    "marketValue": "$49.58M",
    "rawAllocation": 0.0331,
    "rawMarketValue": 49580000
  },
  {
    "ticker": "CLNR",
    "fundName": "IQ Cleaner Transport ETF",
    "segment": "Equity: Global Mobility",
    "allocation": "3.27%",
    "marketValue": "$203.23K",
    "rawAllocation": 0.0327,
    "rawMarketValue": 203230
  },
  {
    "ticker": "DIVB",
    "fundName": "iShares Core Dividend ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "3.27%",
    "marketValue": "$8.23M",
    "rawAllocation": 0.0327,
    "rawMarketValue": 8230000
  },
  {
    "ticker": "TIME",
    "fundName": "Clockwise Capital Innovation ETF",
    "segment": "Equity: U.S. 5G",
    "allocation": "3.20%",
    "marketValue": "$1.81M",
    "rawAllocation": 0.032,
    "rawMarketValue": 1810000
  },
  {
    "ticker": "XSD",
    "fundName": "SPDR S&P Semiconductor ETF",
    "segment": "Equity: U.S. Semiconductors",
    "allocation": "3.20%",
    "marketValue": "$40.88M",
    "rawAllocation": 0.032,
    "rawMarketValue": 40880000
  },
  {
    "ticker": "QDEF",
    "fundName": "FlexShares Quality Dividend Defensive Index Fund",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "3.19%",
    "marketValue": "$10.40M",
    "rawAllocation": 0.0319,
    "rawMarketValue": 10400000
  },
  {
    "ticker": "DIVS",
    "fundName": "SmartETFs Dividend Builder ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "3.17%",
    "marketValue": "$821.76K",
    "rawAllocation": 0.0317,
    "rawMarketValue": 821760
  },
  {
    "ticker": "TECL",
    "fundName": "Direxion Daily Technology Bull 3X Shares",
    "segment": "Leveraged Equity: U.S. Information Technology",
    "allocation": "3.16%",
    "marketValue": "$44.15M",
    "rawAllocation": 0.0316,
    "rawMarketValue": 44150000
  },
  {
    "ticker": "TMFE",
    "fundName": "RBB Fund, Inc. - Motley Fool Capital Efficiency 100 Index ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "3.15%",
    "marketValue": "$624.84K",
    "rawAllocation": 0.0315,
    "rawMarketValue": 624840
  },
  {
    "ticker": "VEGN",
    "fundName": "U.S. Vegan Climate ETF",
    "segment": "Equity: U.S. Agriculture",
    "allocation": "3.14%",
    "marketValue": "$2.07M",
    "rawAllocation": 0.0314,
    "rawMarketValue": 2070000
  },
  {
    "ticker": "DUHP",
    "fundName": "Dimensional US High Profitability ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "3.13%",
    "marketValue": "$71.37M",
    "rawAllocation": 0.0313,
    "rawMarketValue": 71370000
  },
  {
    "ticker": "EMCA",
    "fundName": "Emerge EMPWR Sustainable Dividend Equity ETF",
    "segment": "Equity: U.S.  -  High Dividend Yield",
    "allocation": "3.06%",
    "marketValue": "$32.29K",
    "rawAllocation": 0.0306,
    "rawMarketValue": 32290
  },
  {
    "ticker": "IDAT",
    "fundName": "iShares Future Cloud 5G and Tech ETF",
    "segment": "Equity: Global Internet Services & Infrastructure",
    "allocation": "3.06%",
    "marketValue": "$155.26K",
    "rawAllocation": 0.0306,
    "rawMarketValue": 155260
  },
  {
    "ticker": "SPHQ",
    "fundName": "Invesco S&P 500 Quality ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "3.02%",
    "marketValue": "$144.56M",
    "rawAllocation": 0.0302,
    "rawMarketValue": 144560000
  },
  {
    "ticker": "RUFF",
    "fundName": "Alpha Dog ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.98%",
    "marketValue": "$1.42M",
    "rawAllocation": 0.0298,
    "rawMarketValue": 1420000
  },
  {
    "ticker": "LEAD",
    "fundName": "Siren DIVCON Leaders Dividend ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.94%",
    "marketValue": "$1.22M",
    "rawAllocation": 0.0294,
    "rawMarketValue": 1220000
  },
  {
    "ticker": "CACG",
    "fundName": "ClearBridge All Cap Growth ESG ETF",
    "segment": "Equity: U.S. - Total Market Growth",
    "allocation": "2.93%",
    "marketValue": "$3.04M",
    "rawAllocation": 0.0293,
    "rawMarketValue": 3040000
  },
  {
    "ticker": "PALC",
    "fundName": "Pacer Lunt Large Cap Multi-Factor Alternator ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.87%",
    "marketValue": "$5.92M",
    "rawAllocation": 0.0287,
    "rawMarketValue": 5920000
  },
  {
    "ticker": "XNTK",
    "fundName": "SPDR NYSE Technology ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "2.87%",
    "marketValue": "$12.33M",
    "rawAllocation": 0.0287,
    "rawMarketValue": 12330000
  },
  {
    "ticker": "QTEC",
    "fundName": "First Trust NASDAQ-100-Technology Sector Index Fund",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "2.78%",
    "marketValue": "$43.14M",
    "rawAllocation": 0.0278,
    "rawMarketValue": 43140000
  },
  {
    "ticker": "LOWV",
    "fundName": "AB US Low Volatility Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.77%",
    "marketValue": "$173.86K",
    "rawAllocation": 0.0277,
    "rawMarketValue": 173860
  },
  {
    "ticker": "WFH",
    "fundName": "Direxion Work From Home ETF",
    "segment": "Equity: U.S. Remote Work",
    "allocation": "2.72%",
    "marketValue": "$779.47K",
    "rawAllocation": 0.0272,
    "rawMarketValue": 779470
  },
  {
    "ticker": "PTF",
    "fundName": "Invesco DWA Technology Momentum ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "2.71%",
    "marketValue": "$6.35M",
    "rawAllocation": 0.0271,
    "rawMarketValue": 6350000
  },
  {
    "ticker": "DGRW",
    "fundName": "WisdomTree US Quality Dividend Growth Fund",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.68%",
    "marketValue": "$224.17M",
    "rawAllocation": 0.0268,
    "rawMarketValue": 224170000
  },
  {
    "ticker": "IYW",
    "fundName": "iShares U.S. Technology ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "2.66%",
    "marketValue": "$286.22M",
    "rawAllocation": 0.0266,
    "rawMarketValue": 286220000
  },
  {
    "ticker": "DYNF",
    "fundName": "BlackRock U.S. Equity Factor Rotation ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.63%",
    "marketValue": "$792.75K",
    "rawAllocation": 0.0263,
    "rawMarketValue": 792750
  },
  {
    "ticker": "TDV",
    "fundName": "ProShares S&P Technology Dividend Aristocrats ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "2.62%",
    "marketValue": "$4.22M",
    "rawAllocation": 0.0262,
    "rawMarketValue": 4220000
  },
  {
    "ticker": "FPAG",
    "fundName": "FPA Global Equity ETF",
    "segment": "Equity: Global  - Total Market Value",
    "allocation": "2.57%",
    "marketValue": "$882.98K",
    "rawAllocation": 0.0257,
    "rawMarketValue": 882980
  },
  {
    "ticker": "ROM",
    "fundName": "ProShares Ultra Technology",
    "segment": "Leveraged Equity: U.S. Information Technology",
    "allocation": "2.53%",
    "marketValue": "$11.99M",
    "rawAllocation": 0.0253,
    "rawMarketValue": 11990000
  },
  {
    "ticker": "GDIV",
    "fundName": "Harbor Dividend Growth Leaders ETF",
    "segment": "Equity: Developed Markets  - Large Cap",
    "allocation": "2.47%",
    "marketValue": "$4.07M",
    "rawAllocation": 0.0247,
    "rawMarketValue": 4070000
  },
  {
    "ticker": "IXN",
    "fundName": "iShares Global Tech ETF",
    "segment": "Equity: Global Information Technology",
    "allocation": "2.43%",
    "marketValue": "$76.78M",
    "rawAllocation": 0.0243,
    "rawMarketValue": 76780000
  },
  {
    "ticker": "VPN",
    "fundName": "Global X Data Center REITs and Digital Infrastructure ETF",
    "segment": "Equity: Global Specialized REITs",
    "allocation": "2.43%",
    "marketValue": "$699.31K",
    "rawAllocation": 0.0243,
    "rawMarketValue": 699310
  },
  {
    "ticker": "IPDP",
    "fundName": "Dividend Performers ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.38%",
    "marketValue": "$407.72K",
    "rawAllocation": 0.0238,
    "rawMarketValue": 407720
  },
  {
    "ticker": "DFNV",
    "fundName": "Donoghue Forlines Risk Managed Innovation ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.32%",
    "marketValue": "$1.14M",
    "rawAllocation": 0.0232,
    "rawMarketValue": 1140000
  },
  {
    "ticker": "DVND",
    "fundName": "Touchstone Dividend Select ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.30%",
    "marketValue": "$624.21K",
    "rawAllocation": 0.023,
    "rawMarketValue": 624210
  },
  {
    "ticker": "VGT",
    "fundName": "Vanguard Information Technology ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "2.30%",
    "marketValue": "$1.06B",
    "rawAllocation": 0.023,
    "rawMarketValue": 1060000000
  },
  {
    "ticker": "IGM",
    "fundName": "iShares Expanded Tech Sector ETF",
    "segment": "Equity: North America Broad Technology",
    "allocation": "2.29%",
    "marketValue": "$64.72M",
    "rawAllocation": 0.0229,
    "rawMarketValue": 64720000
  },
  {
    "ticker": "FTEC",
    "fundName": "Fidelity MSCI Information Technology Index ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "2.27%",
    "marketValue": "$138.74M",
    "rawAllocation": 0.0227,
    "rawMarketValue": 138740000
  },
  {
    "ticker": "SPDV",
    "fundName": "AAM S&P 500 High Dividend Value ETF",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "2.26%",
    "marketValue": "$1.52M",
    "rawAllocation": 0.0226,
    "rawMarketValue": 1520000
  },
  {
    "ticker": "NUGO",
    "fundName": "Nuveen Growth Opportunities ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.24%",
    "marketValue": "$56.28M",
    "rawAllocation": 0.0224,
    "rawMarketValue": 56280000
  },
  {
    "ticker": "MBOX",
    "fundName": "Freedom Day Dividend ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.24%",
    "marketValue": "$1.36M",
    "rawAllocation": 0.0224,
    "rawMarketValue": 1360000
  },
  {
    "ticker": "VSLU",
    "fundName": "Applied Finance Valuation Large Cap ETF",
    "segment": "Equity: Global  -  Large Cap",
    "allocation": "2.23%",
    "marketValue": "$668.39K",
    "rawAllocation": 0.0223,
    "rawMarketValue": 668390
  },
  {
    "ticker": "PJFV",
    "fundName": "PGIM Jennison Focused Value ETF",
    "segment": "Equity: Global  - Total Market Value",
    "allocation": "2.22%",
    "marketValue": "$229.11K",
    "rawAllocation": 0.0222,
    "rawMarketValue": 229110
  },
  {
    "ticker": "USMC",
    "fundName": "Principal U.S. Mega-Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.22%",
    "marketValue": "$29.56M",
    "rawAllocation": 0.0222,
    "rawMarketValue": 29560000
  },
  {
    "ticker": "BTHM",
    "fundName": "BlackRock Future U.S. Themes ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.19%",
    "marketValue": "$96.66K",
    "rawAllocation": 0.0219,
    "rawMarketValue": 96660
  },
  {
    "ticker": "FTQI",
    "fundName": "First Trust Nasdaq BuyWrite Income ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.18%",
    "marketValue": "$781.99K",
    "rawAllocation": 0.0218,
    "rawMarketValue": 781990
  },
  {
    "ticker": "VUSE",
    "fundName": "Vident U.S. Equity Strategy ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.16%",
    "marketValue": "$10.70M",
    "rawAllocation": 0.0216,
    "rawMarketValue": 10700000
  },
  {
    "ticker": "WKLY",
    "fundName": "SoFi Weekly Dividend ETF",
    "segment": "Equity: Developed Markets - High Dividend Yield",
    "allocation": "2.14%",
    "marketValue": "$196.92K",
    "rawAllocation": 0.0214,
    "rawMarketValue": 196920
  },
  {
    "ticker": "QGRW",
    "fundName": "WisdomTree U.S. Quality Growth Fund",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "2.09%",
    "marketValue": "$407.09K",
    "rawAllocation": 0.0209,
    "rawMarketValue": 407090
  },
  {
    "ticker": "QYLE",
    "fundName": "Global X Nasdaq 100 ESG Covered Call ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.07%",
    "marketValue": "$54.28K",
    "rawAllocation": 0.0207,
    "rawMarketValue": 54280
  },
  {
    "ticker": "FTGS",
    "fundName": "First Trust Growth Strength ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "2.07%",
    "marketValue": "$109.82K",
    "rawAllocation": 0.0207,
    "rawMarketValue": 109820
  },
  {
    "ticker": "CGGR",
    "fundName": "Capital Group Growth ETF",
    "segment": "Equity: U.S. - Total Market Growth",
    "allocation": "2.07%",
    "marketValue": "$39.83M",
    "rawAllocation": 0.0207,
    "rawMarketValue": 39830000
  },
  {
    "ticker": "QYLD",
    "fundName": "Global X NASDAQ 100 Covered Call ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.04%",
    "marketValue": "$150.72M",
    "rawAllocation": 0.0204,
    "rawMarketValue": 150720000
  },
  {
    "ticker": "QRMI",
    "fundName": "Global X NASDAQ 100 Risk Managed Income ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.04%",
    "marketValue": "$193.76K",
    "rawAllocation": 0.0204,
    "rawMarketValue": 193760
  },
  {
    "ticker": "JHDV",
    "fundName": "John Hancock U.S. High Dividend ETF",
    "segment": "Equity: U.S.  -  High Dividend Yield",
    "allocation": "2.04%",
    "marketValue": "$131.28K",
    "rawAllocation": 0.0204,
    "rawMarketValue": 131280
  },
  {
    "ticker": "TUGN",
    "fundName": "STF Tactical Growth & Income ETF",
    "segment": "Asset Allocation: U.S. Target Outcome",
    "allocation": "2.03%",
    "marketValue": "$417.19K",
    "rawAllocation": 0.0203,
    "rawMarketValue": 417190
  },
  {
    "ticker": "DSTL",
    "fundName": "Distillate U.S. Fundamental Stability & Value ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.02%",
    "marketValue": "$20.26M",
    "rawAllocation": 0.0202,
    "rawMarketValue": 20260000
  },
  {
    "ticker": "QYLG",
    "fundName": "Global X Nasdaq 100 Covered Call & Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.01%",
    "marketValue": "$1.57M",
    "rawAllocation": 0.0201,
    "rawMarketValue": 1570000
  },
  {
    "ticker": "YALL",
    "fundName": "God Bless America ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "2.01%",
    "marketValue": "$651.35K",
    "rawAllocation": 0.0201,
    "rawMarketValue": 651350
  },
  {
    "ticker": "QQMG",
    "fundName": "Invesco ESG NASDAQ 100 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.00%",
    "marketValue": "$219.64K",
    "rawAllocation": 0.02,
    "rawMarketValue": 219640
  },
  {
    "ticker": "QCLR",
    "fundName": "Global X NASDAQ 100 Collar 95-110 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "2.00%",
    "marketValue": "$56.80K",
    "rawAllocation": 0.02,
    "rawMarketValue": 56800
  },
  {
    "ticker": "PTNQ",
    "fundName": "Pacer Trendpilot 100 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.99%",
    "marketValue": "$15.09M",
    "rawAllocation": 0.0199,
    "rawMarketValue": 15090000
  },
  {
    "ticker": "NUSI",
    "fundName": "Nationwide Nasdaq-100 Risk-Managed Income ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.98%",
    "marketValue": "$8.61M",
    "rawAllocation": 0.0198,
    "rawMarketValue": 8610000
  },
  {
    "ticker": "TUG",
    "fundName": "STF Tactical Growth ETF",
    "segment": "Asset Allocation: U.S. Target Outcome",
    "allocation": "1.98%",
    "marketValue": "$2.64M",
    "rawAllocation": 0.0198,
    "rawMarketValue": 2640000
  },
  {
    "ticker": "QQQM",
    "fundName": "Invesco NASDAQ 100 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.98%",
    "marketValue": "$190.55M",
    "rawAllocation": 0.0198,
    "rawMarketValue": 190550000
  },
  {
    "ticker": "QQQ",
    "fundName": "Invesco QQQ Trust",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.98%",
    "marketValue": "$3.47B",
    "rawAllocation": 0.0198,
    "rawMarketValue": 3470000000
  },
  {
    "ticker": "QTR",
    "fundName": "Global X NASDAQ 100 Tail Risk ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.98%",
    "marketValue": "$33.45K",
    "rawAllocation": 0.0198,
    "rawMarketValue": 33450
  },
  {
    "ticker": "FITE",
    "fundName": "SPDR S&P Kensho Future Security ETF",
    "segment": "Equity: U.S. Broad Thematic",
    "allocation": "1.95%",
    "marketValue": "$544.05K",
    "rawAllocation": 0.0195,
    "rawMarketValue": 544050
  },
  {
    "ticker": "SEIQ",
    "fundName": "SEI Enhanced U.S. Large Cap Quality Factor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.89%",
    "marketValue": "$273.29K",
    "rawAllocation": 0.0189,
    "rawMarketValue": 273290
  },
  {
    "ticker": "MGV",
    "fundName": "Vanguard Mega Cap Value ETF",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "1.89%",
    "marketValue": "$112.06M",
    "rawAllocation": 0.0189,
    "rawMarketValue": 112060000
  },
  {
    "ticker": "VYM",
    "fundName": "Vanguard High Dividend Yield ETF",
    "segment": "Equity: U.S.  -  High Dividend Yield",
    "allocation": "1.88%",
    "marketValue": "$911.57M",
    "rawAllocation": 0.0188,
    "rawMarketValue": 911570000
  },
  {
    "ticker": "PSET",
    "fundName": "Principal Quality ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.87%",
    "marketValue": "$581.92K",
    "rawAllocation": 0.0187,
    "rawMarketValue": 581920
  },
  {
    "ticker": "TWIO",
    "fundName": "Trajan Wealth Income Opportunities ETF",
    "segment": "Asset Allocation: U.S. Target Outcome",
    "allocation": "1.86%",
    "marketValue": "$590.13K",
    "rawAllocation": 0.0186,
    "rawMarketValue": 590130
  },
  {
    "ticker": "RNDV",
    "fundName": "First Trust US Equity Dividend Select ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.84%",
    "marketValue": "$444.96K",
    "rawAllocation": 0.0184,
    "rawMarketValue": 444960
  },
  {
    "ticker": "DGRO",
    "fundName": "iShares Core Dividend Growth ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.81%",
    "marketValue": "$414.52M",
    "rawAllocation": 0.0181,
    "rawMarketValue": 414520000
  },
  {
    "ticker": "VIG",
    "fundName": "Vanguard Dividend Appreciation ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.80%",
    "marketValue": "$1.19B",
    "rawAllocation": 0.018,
    "rawMarketValue": 1190000000
  },
  {
    "ticker": "STXD",
    "fundName": "Strive 1000 Dividend Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "1.79%",
    "marketValue": "$212.07K",
    "rawAllocation": 0.0179,
    "rawMarketValue": 212070
  },
  {
    "ticker": "FDRR",
    "fundName": "Fidelity Dividend ETF for Rising Rates",
    "segment": "Equity: Developed Markets - Total Market",
    "allocation": "1.78%",
    "marketValue": "$9.59M",
    "rawAllocation": 0.0178,
    "rawMarketValue": 9590000
  },
  {
    "ticker": "XVOL",
    "fundName": "Acruence Active Hedge U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.77%",
    "marketValue": "$224.06K",
    "rawAllocation": 0.0177,
    "rawMarketValue": 224060
  },
  {
    "ticker": "GSPY",
    "fundName": "Gotham Enhanced 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.74%",
    "marketValue": "$4.75M",
    "rawAllocation": 0.0174,
    "rawMarketValue": 4750000
  },
  {
    "ticker": "SRHQ",
    "fundName": "SRH U.S. Quality ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.73%",
    "marketValue": "$1.84M",
    "rawAllocation": 0.0173,
    "rawMarketValue": 1840000
  },
  {
    "ticker": "COWG",
    "fundName": "Pacer US Large Cap Cash Cows Growth Leaders ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "1.72%",
    "marketValue": "$357.86K",
    "rawAllocation": 0.0172,
    "rawMarketValue": 357860
  },
  {
    "ticker": "RAYD",
    "fundName": "Rayliant Quantitative Developed Market Equity ETF",
    "segment": "Equity: Developed Markets - Total Market",
    "allocation": "1.71%",
    "marketValue": "$958.09K",
    "rawAllocation": 0.0171,
    "rawMarketValue": 958090
  },
  {
    "ticker": "DFND",
    "fundName": "Siren DIVCON Dividend Defender ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.64%",
    "marketValue": "$218.38K",
    "rawAllocation": 0.0164,
    "rawMarketValue": 218380
  },
  {
    "ticker": "SAMT",
    "fundName": "Strategas Macro Thematic Opportunities ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.64%",
    "marketValue": "$1.14M",
    "rawAllocation": 0.0164,
    "rawMarketValue": 1140000
  },
  {
    "ticker": "TYLG",
    "fundName": "Global X Information Technology Covered Call & Growth ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "1.64%",
    "marketValue": "$46.07K",
    "rawAllocation": 0.0164,
    "rawMarketValue": 46070
  },
  {
    "ticker": "FLQL",
    "fundName": "Franklin U.S. Large Cap Multifactor Index ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.63%",
    "marketValue": "$13.92M",
    "rawAllocation": 0.0163,
    "rawMarketValue": 13920000
  },
  {
    "ticker": "QQH",
    "fundName": "HCM Defender 100 Index ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "1.62%",
    "marketValue": "$4.35M",
    "rawAllocation": 0.0162,
    "rawMarketValue": 4350000
  },
  {
    "ticker": "QLD",
    "fundName": "ProShares Ultra QQQ",
    "segment": "Leveraged Equity: U.S.  -  Large Cap",
    "allocation": "1.61%",
    "marketValue": "$65.61M",
    "rawAllocation": 0.0161,
    "rawMarketValue": 65610000
  },
  {
    "ticker": "HIDV",
    "fundName": "AB US High Dividend ETF",
    "segment": "Equity: U.S.  -  High Dividend Yield",
    "allocation": "1.59%",
    "marketValue": "$96.66K",
    "rawAllocation": 0.0159,
    "rawMarketValue": 96660
  },
  {
    "ticker": "YLDE",
    "fundName": "ClearBridge Dividend Strategy ESG ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "1.59%",
    "marketValue": "$480.31K",
    "rawAllocation": 0.0159,
    "rawMarketValue": 480310
  },
  {
    "ticker": "RYT",
    "fundName": "Invesco S&P 500 Equal Weight Technology ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "1.58%",
    "marketValue": "$42.95M",
    "rawAllocation": 0.0158,
    "rawMarketValue": 42950000
  },
  {
    "ticker": "DEW",
    "fundName": "WisdomTree Global High Dividend Fund",
    "segment": "Equity: Global - High Dividend Yield",
    "allocation": "1.56%",
    "marketValue": "$1.77M",
    "rawAllocation": 0.0156,
    "rawMarketValue": 1770000
  },
  {
    "ticker": "USXF",
    "fundName": "iShares ESG Advanced MSCI USA ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.56%",
    "marketValue": "$10.40M",
    "rawAllocation": 0.0156,
    "rawMarketValue": 10400000
  },
  {
    "ticker": "TTAC",
    "fundName": "FCF US Quality ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.56%",
    "marketValue": "$2.86M",
    "rawAllocation": 0.0156,
    "rawMarketValue": 2860000
  },
  {
    "ticker": "QDIV",
    "fundName": "Global X S&P 500 Quality Dividend ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.55%",
    "marketValue": "$1.09M",
    "rawAllocation": 0.0155,
    "rawMarketValue": 1090000
  },
  {
    "ticker": "VTV",
    "fundName": "Vanguard Value ETF",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "1.54%",
    "marketValue": "$1.57B",
    "rawAllocation": 0.0154,
    "rawMarketValue": 1570000000
  },
  {
    "ticker": "FVAL",
    "fundName": "Fidelity Value Factor ETF",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "1.54%",
    "marketValue": "$6.97M",
    "rawAllocation": 0.0154,
    "rawMarketValue": 6970000
  },
  {
    "ticker": "PFM",
    "fundName": "Invesco Dividend Achievers ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.53%",
    "marketValue": "$10.04M",
    "rawAllocation": 0.0153,
    "rawMarketValue": 10040000
  },
  {
    "ticker": "IWY",
    "fundName": "iShares Russell Top 200 Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "1.53%",
    "marketValue": "$96.11M",
    "rawAllocation": 0.0153,
    "rawMarketValue": 96110000
  },
  {
    "ticker": "KOCG",
    "fundName": "FIS Knights of Columbus Global Belief ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "1.52%",
    "marketValue": "$288.73K",
    "rawAllocation": 0.0152,
    "rawMarketValue": 288730
  },
  {
    "ticker": "SCHG",
    "fundName": "Schwab U.S. Large-Cap Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "1.47%",
    "marketValue": "$248.96M",
    "rawAllocation": 0.0147,
    "rawMarketValue": 248960000
  },
  {
    "ticker": "OALC",
    "fundName": "OneAscent Large Cap Core ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.44%",
    "marketValue": "$465.79K",
    "rawAllocation": 0.0144,
    "rawMarketValue": 465790
  },
  {
    "ticker": "JVAL",
    "fundName": "JPMorgan U.S. Value Factor ETF",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "1.43%",
    "marketValue": "$7.54M",
    "rawAllocation": 0.0143,
    "rawMarketValue": 7540000
  },
  {
    "ticker": "JMOM",
    "fundName": "JPMorgan U.S. Momentum Factor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.42%",
    "marketValue": "$3.37M",
    "rawAllocation": 0.0142,
    "rawMarketValue": 3370000
  },
  {
    "ticker": "NXTG",
    "fundName": "First Trust Indxx NextG ETF",
    "segment": "Equity: Global 5G",
    "allocation": "1.42%",
    "marketValue": "$5.89M",
    "rawAllocation": 0.0142,
    "rawMarketValue": 5890000
  },
  {
    "ticker": "FQAL",
    "fundName": "Fidelity Quality Factor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.41%",
    "marketValue": "$3.98M",
    "rawAllocation": 0.0141,
    "rawMarketValue": 3980000
  },
  {
    "ticker": "FXL",
    "fundName": "First Trust Technology AlphaDEX Fund",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "1.41%",
    "marketValue": "$14.39M",
    "rawAllocation": 0.0141,
    "rawMarketValue": 14390000
  },
  {
    "ticker": "XLG",
    "fundName": "Invesco S&P 500 Top 50 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.39%",
    "marketValue": "$30.49M",
    "rawAllocation": 0.0139,
    "rawMarketValue": 30490000
  },
  {
    "ticker": "JQUA",
    "fundName": "JPMorgan U.S. Quality Factor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.38%",
    "marketValue": "$17.34M",
    "rawAllocation": 0.0138,
    "rawMarketValue": 17340000
  },
  {
    "ticker": "TMFC",
    "fundName": "Motley Fool 100 Index ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.37%",
    "marketValue": "$5.87M",
    "rawAllocation": 0.0137,
    "rawMarketValue": 5870000
  },
  {
    "ticker": "SIXA",
    "fundName": "ETC 6 Meridian Mega Cap Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.35%",
    "marketValue": "$2.34M",
    "rawAllocation": 0.0135,
    "rawMarketValue": 2340000
  },
  {
    "ticker": "ONEQ",
    "fundName": "Fidelity NASDAQ Composite Index ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.33%",
    "marketValue": "$57.98M",
    "rawAllocation": 0.0133,
    "rawMarketValue": 57980000
  },
  {
    "ticker": "DLN",
    "fundName": "WisdomTree U.S. LargeCap Dividend Fund",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.32%",
    "marketValue": "$44.89M",
    "rawAllocation": 0.0132,
    "rawMarketValue": 44890000
  },
  {
    "ticker": "SIXH",
    "fundName": "ETC 6 Meridian Hedged Equity-Index Option Strategy ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.31%",
    "marketValue": "$4.63M",
    "rawAllocation": 0.0131,
    "rawMarketValue": 4630000
  },
  {
    "ticker": "DIVD",
    "fundName": "Altrius Global Dividend ETF",
    "segment": "Equity: Global - High Dividend Yield",
    "allocation": "1.31%",
    "marketValue": "$79.52K",
    "rawAllocation": 0.0131,
    "rawMarketValue": 79520
  },
  {
    "ticker": "RFDA",
    "fundName": "RiverFront Dynamic US Dividend Advantage ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.29%",
    "marketValue": "$932.21K",
    "rawAllocation": 0.0129,
    "rawMarketValue": 932210
  },
  {
    "ticker": "CLSE",
    "fundName": "Convergence Long/Short Equity ETF",
    "segment": "Alternatives: Hedge Fund Strategies",
    "allocation": "1.28%",
    "marketValue": "$311.95K",
    "rawAllocation": 0.0128,
    "rawMarketValue": 311950
  },
  {
    "ticker": "FDVV",
    "fundName": "Fidelity High Dividend ETF",
    "segment": "Equity: Developed Markets - High Dividend Yield",
    "allocation": "1.28%",
    "marketValue": "$18.33M",
    "rawAllocation": 0.0128,
    "rawMarketValue": 18330000
  },
  {
    "ticker": "SPUS",
    "fundName": "SP Funds S&P 500 Sharia Industry Exclusions ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.27%",
    "marketValue": "$2.88M",
    "rawAllocation": 0.0127,
    "rawMarketValue": 2880000
  },
  {
    "ticker": "IWF",
    "fundName": "iShares Russell 1000 Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "1.26%",
    "marketValue": "$801.39M",
    "rawAllocation": 0.0126,
    "rawMarketValue": 801390000
  },
  {
    "ticker": "VONG",
    "fundName": "Vanguard Russell 1000 Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "1.26%",
    "marketValue": "$143.41M",
    "rawAllocation": 0.0126,
    "rawMarketValue": 143410000
  },
  {
    "ticker": "FIVG",
    "fundName": "Defiance Next Gen Connectivity ETF",
    "segment": "Equity: Global 5G",
    "allocation": "1.25%",
    "marketValue": "$7.78M",
    "rawAllocation": 0.0125,
    "rawMarketValue": 7780000
  },
  {
    "ticker": "DDIV",
    "fundName": "First Trust Dorsey Wright Momentum & Dividend ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.25%",
    "marketValue": "$610.32K",
    "rawAllocation": 0.0125,
    "rawMarketValue": 610320
  },
  {
    "ticker": "RFFC",
    "fundName": "RiverFront Dynamic U.S. Flex-Cap ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.23%",
    "marketValue": "$267.61K",
    "rawAllocation": 0.0123,
    "rawMarketValue": 267610
  },
  {
    "ticker": "JEPQ",
    "fundName": "JPMorgan Nasdaq Equity Premium Income ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.22%",
    "marketValue": "$26.32M",
    "rawAllocation": 0.0122,
    "rawMarketValue": 26320000
  },
  {
    "ticker": "CDEI",
    "fundName": "Calvert US Large-Cap Diversity, Equity and Inclusion Index ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.17%",
    "marketValue": "$278.46K",
    "rawAllocation": 0.0117,
    "rawMarketValue": 278460
  },
  {
    "ticker": "UDIV",
    "fundName": "Franklin U.S. Core Dividend Tilt Index ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.17%",
    "marketValue": "$279.60K",
    "rawAllocation": 0.0117,
    "rawMarketValue": 279600
  },
  {
    "ticker": "ADIV",
    "fundName": "SmartETFs Asia Pacific Dividend Builder ETF",
    "segment": "Equity: Asia-Pacific - Total Market",
    "allocation": "1.17%",
    "marketValue": "$36.61K",
    "rawAllocation": 0.0117,
    "rawMarketValue": 36610
  },
  {
    "ticker": "MMTM",
    "fundName": "SPDR S&P 1500 Momentum Tilt ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.15%",
    "marketValue": "$886.13K",
    "rawAllocation": 0.0115,
    "rawMarketValue": 886130
  },
  {
    "ticker": "OEF",
    "fundName": "iShares S&P 100 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.14%",
    "marketValue": "$87.22M",
    "rawAllocation": 0.0114,
    "rawMarketValue": 87220000
  },
  {
    "ticker": "DTD",
    "fundName": "WisdomTree U.S. Total Dividend Fund",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.13%",
    "marketValue": "$11.84M",
    "rawAllocation": 0.0113,
    "rawMarketValue": 11840000
  },
  {
    "ticker": "QGRO",
    "fundName": "American Century STOXX U.S. Quality Growth ETF",
    "segment": "Equity: U.S. - Total Market Growth",
    "allocation": "1.12%",
    "marketValue": "$4.86M",
    "rawAllocation": 0.0112,
    "rawMarketValue": 4860000
  },
  {
    "ticker": "APUE",
    "fundName": "ActivePassive US Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.12%",
    "marketValue": "$1.63M",
    "rawAllocation": 0.0112,
    "rawMarketValue": 1630000
  },
  {
    "ticker": "USCA",
    "fundName": "Xtrackers MSCI USA Climate Action Equity ETF",
    "segment": "Equity: U.S. Environment",
    "allocation": "1.10%",
    "marketValue": "$22.76M",
    "rawAllocation": 0.011,
    "rawMarketValue": 22760000
  },
  {
    "ticker": "HEET",
    "fundName": "Hartford Schroders ESG US Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.09%",
    "marketValue": "$100.98K",
    "rawAllocation": 0.0109,
    "rawMarketValue": 100980
  },
  {
    "ticker": "EVUS",
    "fundName": "iShares ESG Aware MSCI USA Value ETF",
    "segment": "Equity: U.S.  -  Total Market Value",
    "allocation": "1.08%",
    "marketValue": "$41.02K",
    "rawAllocation": 0.0108,
    "rawMarketValue": 41020
  },
  {
    "ticker": "ACIO",
    "fundName": "Aptus Collared Investment Opportunity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.07%",
    "marketValue": "$6.22M",
    "rawAllocation": 0.0107,
    "rawMarketValue": 6220000
  },
  {
    "ticker": "ADME",
    "fundName": "Aptus Drawdown Managed Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.07%",
    "marketValue": "$2.08M",
    "rawAllocation": 0.0107,
    "rawMarketValue": 2080000
  },
  {
    "ticker": "LRND",
    "fundName": "IQ U.S. Large Cap R&D Leaders ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.07%",
    "marketValue": "$49.23K",
    "rawAllocation": 0.0107,
    "rawMarketValue": 49230
  },
  {
    "ticker": "AFLG",
    "fundName": "First Trust Active Factor Large Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.06%",
    "marketValue": "$50.49K",
    "rawAllocation": 0.0106,
    "rawMarketValue": 50490
  },
  {
    "ticker": "PEXL",
    "fundName": "Pacer U.S. Export Leaders ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.04%",
    "marketValue": "$201.97K",
    "rawAllocation": 0.0104,
    "rawMarketValue": 201970
  },
  {
    "ticker": "FLRG",
    "fundName": "Fidelity US Multifactor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.02%",
    "marketValue": "$268.02K",
    "rawAllocation": 0.0102,
    "rawMarketValue": 268020
  },
  {
    "ticker": "SPHB",
    "fundName": "Invesco S&P 500 High Beta ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.02%",
    "marketValue": "$4.57M",
    "rawAllocation": 0.0102,
    "rawMarketValue": 4570000
  },
  {
    "ticker": "EMPW",
    "fundName": "Emerge EMPWR Unified Sustainable Equity ETF - US",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "1.02%",
    "marketValue": "$5.05K",
    "rawAllocation": 0.0102,
    "rawMarketValue": 5050
  },
  {
    "ticker": "XOUT",
    "fundName": "GraniteShares XOUT U.S. Large Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.01%",
    "marketValue": "$725.82K",
    "rawAllocation": 0.0101,
    "rawMarketValue": 725820
  },
  {
    "ticker": "VDNI",
    "fundName": "V-Shares US Leadership Diversity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.01%",
    "marketValue": "$11.36K",
    "rawAllocation": 0.0101,
    "rawMarketValue": 11360
  },
  {
    "ticker": "IQSU",
    "fundName": "IQ Candriam ESG U.S. Large Cap Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.01%",
    "marketValue": "$3.78M",
    "rawAllocation": 0.0101,
    "rawMarketValue": 3780000
  },
  {
    "ticker": "LRGF",
    "fundName": "iShares US Equity Factor ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.01%",
    "marketValue": "$12.40M",
    "rawAllocation": 0.0101,
    "rawMarketValue": 12400000
  },
  {
    "ticker": "CLRG",
    "fundName": "IQ Chaikin U.S. Large Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.00%",
    "marketValue": "$2.73M",
    "rawAllocation": 0.01,
    "rawMarketValue": 2730000
  },
  {
    "ticker": "SENT",
    "fundName": "AdvisorShares Alpha DNA Equity Sentiment ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "1.00%",
    "marketValue": "$392.58K",
    "rawAllocation": 0.01,
    "rawMarketValue": 392580
  },
  {
    "ticker": "EQWL",
    "fundName": "Invesco S&P 100 Equal Weight ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "1.00%",
    "marketValue": "$2.26M",
    "rawAllocation": 0.01,
    "rawMarketValue": 2260000
  },
  {
    "ticker": "STXG",
    "fundName": "Strive 1000 Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "1.00%",
    "marketValue": "$99.72K",
    "rawAllocation": 0.01,
    "rawMarketValue": 99720
  },
  {
    "ticker": "FWD",
    "fundName": "AB Disruptors ETF",
    "segment": "Equity: Global Broad Thematic",
    "allocation": "0.99%",
    "marketValue": "$144.99K",
    "rawAllocation": 0.0099,
    "rawMarketValue": 144990
  },
  {
    "ticker": "STLG",
    "fundName": "iShares Factors U.S. Growth Style ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "0.99%",
    "marketValue": "$82.05K",
    "rawAllocation": 0.0099,
    "rawMarketValue": 82050
  },
  {
    "ticker": "FDLS",
    "fundName": "Inspire Fidelis Multi Factor ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.99%",
    "marketValue": "$513.76K",
    "rawAllocation": 0.0099,
    "rawMarketValue": 513760
  },
  {
    "ticker": "ILDR",
    "fundName": "First Trust Innovation Leaders ETF",
    "segment": "Equity: Global Broad Thematic",
    "allocation": "0.98%",
    "marketValue": "$31.56K",
    "rawAllocation": 0.0098,
    "rawMarketValue": 31560
  },
  {
    "ticker": "FLSP",
    "fundName": "Franklin Systematic Style Premia ETF",
    "segment": "Alternatives: Hedge Fund Strategies",
    "allocation": "0.98%",
    "marketValue": "$924.00K",
    "rawAllocation": 0.0098,
    "rawMarketValue": 924000
  },
  {
    "ticker": "QQQE",
    "fundName": "Direxion NASDAQ-100 Equal Weighted Index Shares",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.97%",
    "marketValue": "$5.79M",
    "rawAllocation": 0.0097,
    "rawMarketValue": 5790000
  },
  {
    "ticker": "QQEW",
    "fundName": "First Trust Nasdaq-100 Equal Weighted Index Fund",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.97%",
    "marketValue": "$15.46M",
    "rawAllocation": 0.0097,
    "rawMarketValue": 15460000
  },
  {
    "ticker": "HDUS",
    "fundName": "Hartford Disciplined US Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.96%",
    "marketValue": "$59.33K",
    "rawAllocation": 0.0096,
    "rawMarketValue": 59330
  },
  {
    "ticker": "QUS",
    "fundName": "SPDR MSCI USA StrategicFactors ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.96%",
    "marketValue": "$9.16M",
    "rawAllocation": 0.0096,
    "rawMarketValue": 9160000
  },
  {
    "ticker": "TPHE",
    "fundName": "Timothy Plan High Dividend Stock Enhanced ETF",
    "segment": "Equity: U.S.  -  High Dividend Yield",
    "allocation": "0.95%",
    "marketValue": "$675.96K",
    "rawAllocation": 0.0095,
    "rawMarketValue": 675960
  },
  {
    "ticker": "TPHD",
    "fundName": "Timothy Plan High Dividend Stock ETF",
    "segment": "Equity: U.S.  -  High Dividend Yield",
    "allocation": "0.95%",
    "marketValue": "$1.73M",
    "rawAllocation": 0.0095,
    "rawMarketValue": 1730000
  },
  {
    "ticker": "ICAP",
    "fundName": "InfraCap Equity Income Fund ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.95%",
    "marketValue": "$421.17K",
    "rawAllocation": 0.0095,
    "rawMarketValue": 421170
  },
  {
    "ticker": "LVOL",
    "fundName": "American Century Low Volatility ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.94%",
    "marketValue": "$80.16K",
    "rawAllocation": 0.0094,
    "rawMarketValue": 80160
  },
  {
    "ticker": "DFSU",
    "fundName": "Dimensional US Sustainability Core 1 ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.91%",
    "marketValue": "$3.62M",
    "rawAllocation": 0.0091,
    "rawMarketValue": 3620000
  },
  {
    "ticker": "SPXN",
    "fundName": "ProShares S&P 500 Ex-Financials ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.90%",
    "marketValue": "$235.42K",
    "rawAllocation": 0.009,
    "rawMarketValue": 235420
  },
  {
    "ticker": "SPXV",
    "fundName": "ProShares S&P 500 Ex-Health Care ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.89%",
    "marketValue": "$110.45K",
    "rawAllocation": 0.0089,
    "rawMarketValue": 110450
  },
  {
    "ticker": "BKLC",
    "fundName": "BNY Mellon US Large Cap Core Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.89%",
    "marketValue": "$15.47M",
    "rawAllocation": 0.0089,
    "rawMarketValue": 15470000
  },
  {
    "ticker": "TQQQ",
    "fundName": "ProShares UltraPro QQQ",
    "segment": "Leveraged Equity: U.S.  -  Large Cap",
    "allocation": "0.89%",
    "marketValue": "$119.25M",
    "rawAllocation": 0.0089,
    "rawMarketValue": 119250000
  },
  {
    "ticker": "EPS",
    "fundName": "WisdomTree U.S. LargeCap Fund",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.88%",
    "marketValue": "$5.80M",
    "rawAllocation": 0.0088,
    "rawMarketValue": 5800000
  },
  {
    "ticker": "MGC",
    "fundName": "Vanguard Mega Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.88%",
    "marketValue": "$33.75M",
    "rawAllocation": 0.0088,
    "rawMarketValue": 33750000
  },
  {
    "ticker": "IWL",
    "fundName": "iShares Russell Top 200 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.87%",
    "marketValue": "$7.01M",
    "rawAllocation": 0.0087,
    "rawMarketValue": 7010000
  },
  {
    "ticker": "SFLR",
    "fundName": "Innovator Equity Managed Floor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.87%",
    "marketValue": "$193.13K",
    "rawAllocation": 0.0087,
    "rawMarketValue": 193130
  },
  {
    "ticker": "RNLC",
    "fundName": "First Trust Large Cap U.S. Equity Select ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.87%",
    "marketValue": "$143.27K",
    "rawAllocation": 0.0087,
    "rawMarketValue": 143270
  },
  {
    "ticker": "SPYG",
    "fundName": "SPDR Portfolio S&P 500 Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "0.85%",
    "marketValue": "$141.82M",
    "rawAllocation": 0.0085,
    "rawMarketValue": 141820000
  },
  {
    "ticker": "SFY",
    "fundName": "SoFi Select 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "0.85%",
    "marketValue": "$3.88M",
    "rawAllocation": 0.0085,
    "rawMarketValue": 3880000
  },
  {
    "ticker": "IVW",
    "fundName": "iShares S&P 500 Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "0.85%",
    "marketValue": "$259.60M",
    "rawAllocation": 0.0085,
    "rawMarketValue": 259600000
  },
  {
    "ticker": "XVV",
    "fundName": "iShares ESG Screened S&P 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.85%",
    "marketValue": "$1.34M",
    "rawAllocation": 0.0085,
    "rawMarketValue": 1340000
  },
  {
    "ticker": "ROUS",
    "fundName": "Hartford Multifactor US Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.85%",
    "marketValue": "$3.63M",
    "rawAllocation": 0.0085,
    "rawMarketValue": 3630000
  },
  {
    "ticker": "VOOG",
    "fundName": "Vanguard S&P 500 Growth Index Fund ",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "0.85%",
    "marketValue": "$60.46M",
    "rawAllocation": 0.0085,
    "rawMarketValue": 60460000
  },
  {
    "ticker": "FCPI",
    "fundName": "Fidelity Stocks for Inflation ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.85%",
    "marketValue": "$1.54M",
    "rawAllocation": 0.0085,
    "rawMarketValue": 1540000
  },
  {
    "ticker": "QLC",
    "fundName": "FlexShares US Quality Large Cap Index Fund",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.84%",
    "marketValue": "$1.02M",
    "rawAllocation": 0.0084,
    "rawMarketValue": 1020000
  },
  {
    "ticker": "USNZ",
    "fundName": "Xtrackers Net Zero Pathway Paris Aligned US Equity ETF",
    "segment": "Equity: U.S. Low Carbon",
    "allocation": "0.84%",
    "marketValue": "$1.00M",
    "rawAllocation": 0.0084,
    "rawMarketValue": 1000000
  },
  {
    "ticker": "UVDV",
    "fundName": "UVA Dividend Value ETF",
    "segment": "Equity: Global  - Total Market Value",
    "allocation": "0.83%",
    "marketValue": "$148.32K",
    "rawAllocation": 0.0083,
    "rawMarketValue": 148320
  },
  {
    "ticker": "CAPE",
    "fundName": "DoubleLine Shiller CAPE U.S. Equities ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.82%",
    "marketValue": "$2.01M",
    "rawAllocation": 0.0082,
    "rawMarketValue": 2010000
  },
  {
    "ticker": "ACVF",
    "fundName": "American Conservative Values ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.81%",
    "marketValue": "$327.57K",
    "rawAllocation": 0.0081,
    "rawMarketValue": 327570
  },
  {
    "ticker": "CVLC",
    "fundName": "Calvert US Large-Cap Core Responsible Index ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.81%",
    "marketValue": "$1.16M",
    "rawAllocation": 0.0081,
    "rawMarketValue": 1160000
  },
  {
    "ticker": "IUSG",
    "fundName": "iShares Core S&P U.S. Growth ETF",
    "segment": "Equity: U.S. - Total Market Growth",
    "allocation": "0.81%",
    "marketValue": "$100.81M",
    "rawAllocation": 0.0081,
    "rawMarketValue": 100810000
  },
  {
    "ticker": "QVML",
    "fundName": "Invesco S&P 500 QVM Multi-Factor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.80%",
    "marketValue": "$7.12M",
    "rawAllocation": 0.008,
    "rawMarketValue": 7120000
  },
  {
    "ticker": "JOET",
    "fundName": "Virtus Terranova U.S. Quality Momentum ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.80%",
    "marketValue": "$832.92K",
    "rawAllocation": 0.008,
    "rawMarketValue": 832920
  },
  {
    "ticker": "SPXE",
    "fundName": "ProShares S&P 500 Ex-Energy ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.80%",
    "marketValue": "$277.07K",
    "rawAllocation": 0.008,
    "rawMarketValue": 277070
  },
  {
    "ticker": "SPYX",
    "fundName": "SPDR S&P 500 Fossil Fuel Reserves Free ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.79%",
    "marketValue": "$9.90M",
    "rawAllocation": 0.0079,
    "rawMarketValue": 9900000
  },
  {
    "ticker": "CGGO",
    "fundName": "Capital Group Global Growth Equity ETF",
    "segment": "Equity: Global - Total Market Growth",
    "allocation": "0.78%",
    "marketValue": "$12.16M",
    "rawAllocation": 0.0078,
    "rawMarketValue": 12160000
  },
  {
    "ticker": "ILCV",
    "fundName": "iShares Morningstar Value ETF",
    "segment": "Equity: U.S.  -  Total Market Value",
    "allocation": "0.77%",
    "marketValue": "$5.91M",
    "rawAllocation": 0.0077,
    "rawMarketValue": 5910000
  },
  {
    "ticker": "CATH",
    "fundName": "Global X S&P 500 Catholic Values ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.77%",
    "marketValue": "$4.84M",
    "rawAllocation": 0.0077,
    "rawMarketValue": 4840000
  },
  {
    "ticker": "PBP",
    "fundName": "Invesco S&P 500 BuyWrite ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.77%",
    "marketValue": "$722.67K",
    "rawAllocation": 0.0077,
    "rawMarketValue": 722670
  },
  {
    "ticker": "SPY",
    "fundName": "SPDR S&P 500 ETF Trust",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$2.91B",
    "rawAllocation": 0.0076,
    "rawMarketValue": 2910000000
  },
  {
    "ticker": "XYLG",
    "fundName": "Global X S&P 500 Covered Call & Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$438.65K",
    "rawAllocation": 0.0076,
    "rawMarketValue": 438650
  },
  {
    "ticker": "XRMI",
    "fundName": "Global X S&P 500 Risk Managed Income ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$200.71K",
    "rawAllocation": 0.0076,
    "rawMarketValue": 200710
  },
  {
    "ticker": "IVV",
    "fundName": "iShares Core S&P 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$2.34B",
    "rawAllocation": 0.0076,
    "rawMarketValue": 2340000000
  },
  {
    "ticker": "PTLC",
    "fundName": "Pacer Trendpilot U.S. Large Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$15.40M",
    "rawAllocation": 0.0076,
    "rawMarketValue": 15400000
  },
  {
    "ticker": "SPLG",
    "fundName": "SPDR Portfolio S&P 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$127.98M",
    "rawAllocation": 0.0076,
    "rawMarketValue": 127980000
  },
  {
    "ticker": "XCLR",
    "fundName": "Global X S&P 500 Collar 95-110 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$24.61K",
    "rawAllocation": 0.0076,
    "rawMarketValue": 24610
  },
  {
    "ticker": "ULVM",
    "fundName": "VictoryShares US Value Momentum ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$1.72M",
    "rawAllocation": 0.0076,
    "rawMarketValue": 1720000
  },
  {
    "ticker": "HIBL",
    "fundName": "Direxion Daily S&P 500 High Beta Bull 3X Shares",
    "segment": "Leveraged Equity: U.S.  -  Large Cap",
    "allocation": "0.76%",
    "marketValue": "$477.78K",
    "rawAllocation": 0.0076,
    "rawMarketValue": 477780
  },
  {
    "ticker": "ESGV",
    "fundName": "Vanguard ESG U.S. Stock ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.75%",
    "marketValue": "$46.19M",
    "rawAllocation": 0.0075,
    "rawMarketValue": 46190000
  },
  {
    "ticker": "XTR",
    "fundName": "Global X S&P 500 Tail Risk ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.75%",
    "marketValue": "$23.35K",
    "rawAllocation": 0.0075,
    "rawMarketValue": 23350
  },
  {
    "ticker": "VOTE",
    "fundName": "Engine No. 1 Transform 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.75%",
    "marketValue": "$3.29M",
    "rawAllocation": 0.0075,
    "rawMarketValue": 3290000
  },
  {
    "ticker": "JUST",
    "fundName": "Goldman Sachs JUST U.S. Large Cap Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.75%",
    "marketValue": "$2.02M",
    "rawAllocation": 0.0075,
    "rawMarketValue": 2020000
  },
  {
    "ticker": "VOO",
    "fundName": "Vanguard 500 Index Fund",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.75%",
    "marketValue": "$2.18B",
    "rawAllocation": 0.0075,
    "rawMarketValue": 2180000000
  },
  {
    "ticker": "DFAU",
    "fundName": "Dimensional U.S. Core Equity Market ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.75%",
    "marketValue": "$24.75M",
    "rawAllocation": 0.0075,
    "rawMarketValue": 24750000
  },
  {
    "ticker": "NSPI",
    "fundName": "Nationwide S&P 500 Risk-Managed Income ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.75%",
    "marketValue": "$128.75K",
    "rawAllocation": 0.0075,
    "rawMarketValue": 128750
  },
  {
    "ticker": "GSUS",
    "fundName": "Goldman Sachs MarketBeta U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.74%",
    "marketValue": "$6.52M",
    "rawAllocation": 0.0074,
    "rawMarketValue": 6520000
  },
  {
    "ticker": "USPX",
    "fundName": "Franklin U.S. Equity Index ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.74%",
    "marketValue": "$5.18M",
    "rawAllocation": 0.0074,
    "rawMarketValue": 5180000
  },
  {
    "ticker": "MODL",
    "fundName": "VictoryShares WestEnd U.S. Sector ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.74%",
    "marketValue": "$1.19M",
    "rawAllocation": 0.0074,
    "rawMarketValue": 1190000
  },
  {
    "ticker": "STRV",
    "fundName": "Strive 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.74%",
    "marketValue": "$1.14M",
    "rawAllocation": 0.0074,
    "rawMarketValue": 1140000
  },
  {
    "ticker": "ONOF",
    "fundName": "Global X Adaptive U.S. Risk Management ETF",
    "segment": "Asset Allocation: U.S. Target Outcome",
    "allocation": "0.74%",
    "marketValue": "$504.92K",
    "rawAllocation": 0.0074,
    "rawMarketValue": 504920
  },
  {
    "ticker": "TSPA",
    "fundName": "T. Rowe Price U.S. Equity Research ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.74%",
    "marketValue": "$189.98K",
    "rawAllocation": 0.0074,
    "rawMarketValue": 189980
  },
  {
    "ticker": "VV",
    "fundName": "Vanguard Large Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.73%",
    "marketValue": "$191.51M",
    "rawAllocation": 0.0073,
    "rawMarketValue": 191510000
  },
  {
    "ticker": "LCTU",
    "fundName": "BlackRock U.S. Carbon Transition Readiness ETF",
    "segment": "Equity: U.S. Low Carbon",
    "allocation": "0.73%",
    "marketValue": "$10.38M",
    "rawAllocation": 0.0073,
    "rawMarketValue": 10380000
  },
  {
    "ticker": "BBUS",
    "fundName": "JPMorgan BetaBuilders U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.73%",
    "marketValue": "$11.10M",
    "rawAllocation": 0.0073,
    "rawMarketValue": 11100000
  },
  {
    "ticker": "PBUS",
    "fundName": "Invesco PureBeta MSCI USA ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.72%",
    "marketValue": "$16.71M",
    "rawAllocation": 0.0072,
    "rawMarketValue": 16710000
  },
  {
    "ticker": "FTC",
    "fundName": "First Trust Large Cap Growth AlphaDEX Fund",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "0.72%",
    "marketValue": "$6.54M",
    "rawAllocation": 0.0072,
    "rawMarketValue": 6540000
  },
  {
    "ticker": "SPUU",
    "fundName": "Direxion Daily S&P 500 Bull 2X Shares",
    "segment": "Leveraged Equity: U.S.  -  Large Cap",
    "allocation": "0.72%",
    "marketValue": "$1.63M",
    "rawAllocation": 0.0072,
    "rawMarketValue": 1630000
  },
  {
    "ticker": "HLGE",
    "fundName": "Hartford Longevity Economy ETF",
    "segment": "Equity: U.S. Consumer",
    "allocation": "0.72%",
    "marketValue": "$58.70K",
    "rawAllocation": 0.0072,
    "rawMarketValue": 58700
  },
  {
    "ticker": "ILCB",
    "fundName": "iShares Morningstar U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.71%",
    "marketValue": "$5.23M",
    "rawAllocation": 0.0071,
    "rawMarketValue": 5230000
  },
  {
    "ticker": "SCHX",
    "fundName": "Schwab U.S. Large-Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.71%",
    "marketValue": "$218.91M",
    "rawAllocation": 0.0071,
    "rawMarketValue": 218910000
  },
  {
    "ticker": "ZSPY",
    "fundName": "ASYMmetric Smart Alpha S&P 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.71%",
    "marketValue": "$5.05K",
    "rawAllocation": 0.0071,
    "rawMarketValue": 5050
  },
  {
    "ticker": "DFAC",
    "fundName": "Dimensional U.S. Core Equity 2 ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.71%",
    "marketValue": "$132.00M",
    "rawAllocation": 0.0071,
    "rawMarketValue": 132000000
  },
  {
    "ticker": "SPYI",
    "fundName": "NEOS S&P 500 High Income ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.71%",
    "marketValue": "$101.62K",
    "rawAllocation": 0.0071,
    "rawMarketValue": 101620
  },
  {
    "ticker": "TRPL",
    "fundName": "Pacer Metaurus US Large Cap Dividend Multiplier 300 ETF",
    "segment": "Asset Allocation: U.S. Target Outcome",
    "allocation": "0.71%",
    "marketValue": "$6.31K",
    "rawAllocation": 0.0071,
    "rawMarketValue": 6310
  },
  {
    "ticker": "SPTM",
    "fundName": "SPDR Portfolio S&P 1500 Composite Stock Market ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.70%",
    "marketValue": "$41.82M",
    "rawAllocation": 0.007,
    "rawMarketValue": 41820000
  },
  {
    "ticker": "FTHI",
    "fundName": "First Trust BuyWrite Income ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.70%",
    "marketValue": "$1.24M",
    "rawAllocation": 0.007,
    "rawMarketValue": 1240000
  },
  {
    "ticker": "SCHK",
    "fundName": "Schwab 1000 Index ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.69%",
    "marketValue": "$18.33M",
    "rawAllocation": 0.0069,
    "rawMarketValue": 18330000
  },
  {
    "ticker": "DFUS",
    "fundName": "Dimensional U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.69%",
    "marketValue": "$41.92M",
    "rawAllocation": 0.0069,
    "rawMarketValue": 41920000
  },
  {
    "ticker": "IYY",
    "fundName": "iShares Dow Jones U.S. ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.69%",
    "marketValue": "$10.50M",
    "rawAllocation": 0.0069,
    "rawMarketValue": 10500000
  },
  {
    "ticker": "GUSA",
    "fundName": "Goldman Sachs MarketBeta US 1000 Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.68%",
    "marketValue": "$8.64M",
    "rawAllocation": 0.0068,
    "rawMarketValue": 8640000
  },
  {
    "ticker": "VONE",
    "fundName": "Vanguard Russell 1000 Index Fund",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.67%",
    "marketValue": "$22.90M",
    "rawAllocation": 0.0067,
    "rawMarketValue": 22900000
  },
  {
    "ticker": "ILCG",
    "fundName": "iShare Morningstar Growth ETF",
    "segment": "Equity: U.S. - Total Market Growth",
    "allocation": "0.66%",
    "marketValue": "$10.54M",
    "rawAllocation": 0.0066,
    "rawMarketValue": 10540000
  },
  {
    "ticker": "VTI",
    "fundName": "Vanguard Total Stock Market ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.66%",
    "marketValue": "$1.84B",
    "rawAllocation": 0.0066,
    "rawMarketValue": 1840000000
  },
  {
    "ticker": "IVE",
    "fundName": "iShares S&P 500 Value ETF",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "0.66%",
    "marketValue": "$157.87M",
    "rawAllocation": 0.0066,
    "rawMarketValue": 157870000
  },
  {
    "ticker": "SPYV",
    "fundName": "SPDR Portfolio S&P 500 Value ETF",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "0.66%",
    "marketValue": "$96.54M",
    "rawAllocation": 0.0066,
    "rawMarketValue": 96540000
  },
  {
    "ticker": "SCHB",
    "fundName": "Schwab U.S. Broad Market ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.66%",
    "marketValue": "$139.82M",
    "rawAllocation": 0.0066,
    "rawMarketValue": 139820000
  },
  {
    "ticker": "IWB",
    "fundName": "iShares Russell 1000 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.66%",
    "marketValue": "$187.03M",
    "rawAllocation": 0.0066,
    "rawMarketValue": 187030000
  },
  {
    "ticker": "QDPL",
    "fundName": "Pacer Metaurus US Large Cap Dividend Multiplier 400 ETF",
    "segment": "Asset Allocation: U.S. Target Outcome",
    "allocation": "0.66%",
    "marketValue": "$723.93K",
    "rawAllocation": 0.0066,
    "rawMarketValue": 723930
  },
  {
    "ticker": "ITOT",
    "fundName": "iShares Core S&P Total U.S. Stock Market ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.65%",
    "marketValue": "$268.88M",
    "rawAllocation": 0.0065,
    "rawMarketValue": 268880000
  },
  {
    "ticker": "CSM",
    "fundName": "ProShares Large Cap Core Plus",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.64%",
    "marketValue": "$2.61M",
    "rawAllocation": 0.0064,
    "rawMarketValue": 2610000
  },
  {
    "ticker": "UPRO",
    "fundName": "ProShares UltraPro S&P500",
    "segment": "Leveraged Equity: U.S.  -  Large Cap",
    "allocation": "0.64%",
    "marketValue": "$15.01M",
    "rawAllocation": 0.0064,
    "rawMarketValue": 15010000
  },
  {
    "ticker": "SSO",
    "fundName": "ProShares Ultra S&P 500",
    "segment": "Leveraged Equity: U.S.  -  Large Cap",
    "allocation": "0.64%",
    "marketValue": "$22.00M",
    "rawAllocation": 0.0064,
    "rawMarketValue": 22000000
  },
  {
    "ticker": "VOOV",
    "fundName": "Vanguard S&P 500 Value ETF",
    "segment": "Equity: U.S.  -  Large Cap Value",
    "allocation": "0.64%",
    "marketValue": "$20.69M",
    "rawAllocation": 0.0064,
    "rawMarketValue": 20690000
  },
  {
    "ticker": "GPAL",
    "fundName": "Goldman Sachs ActiveBeta Paris-Aligned US Large Cap Equity ETF",
    "segment": "Equity: U.S. Low Carbon",
    "allocation": "0.63%",
    "marketValue": "$54.28K",
    "rawAllocation": 0.0063,
    "rawMarketValue": 54280
  },
  {
    "ticker": "VTHR",
    "fundName": "Vanguard Russell 3000 ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.63%",
    "marketValue": "$10.00M",
    "rawAllocation": 0.0063,
    "rawMarketValue": 10000000
  },
  {
    "ticker": "MVPS",
    "fundName": "Amplify Thematic All-Stars ETF",
    "segment": "Equity: Global Broad Thematic",
    "allocation": "0.63%",
    "marketValue": "$23.98K",
    "rawAllocation": 0.0063,
    "rawMarketValue": 23980
  },
  {
    "ticker": "TILT",
    "fundName": "FlexShares Morningstar US Market Factor Tilt Index Fund",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.62%",
    "marketValue": "$8.54M",
    "rawAllocation": 0.0062,
    "rawMarketValue": 8540000
  },
  {
    "ticker": "IUSV",
    "fundName": "iShares Core S&P U.S. Value ETF",
    "segment": "Equity: U.S.  -  Total Market Value",
    "allocation": "0.62%",
    "marketValue": "$81.00M",
    "rawAllocation": 0.0062,
    "rawMarketValue": 81000000
  },
  {
    "ticker": "IWV",
    "fundName": "iShares Russell 3000 ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.62%",
    "marketValue": "$66.21M",
    "rawAllocation": 0.0062,
    "rawMarketValue": 66210000
  },
  {
    "ticker": "PHDG",
    "fundName": "Invesco S&P 500 Downside Hedged ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.62%",
    "marketValue": "$1.18M",
    "rawAllocation": 0.0062,
    "rawMarketValue": 1180000
  },
  {
    "ticker": "WINN",
    "fundName": "Harbor Long-Term Growers ETF",
    "segment": "Equity: U.S. - Total Market Growth",
    "allocation": "0.61%",
    "marketValue": "$672.61K",
    "rawAllocation": 0.0061,
    "rawMarketValue": 672610
  },
  {
    "ticker": "GDE",
    "fundName": "WisdomTree Efficient Gold Plus Equity Strategy Fund",
    "segment": "Leveraged Asset Allocation: Global - Target Outcome",
    "allocation": "0.61%",
    "marketValue": "$46.71K",
    "rawAllocation": 0.0061,
    "rawMarketValue": 46710
  },
  {
    "ticker": "VFMF",
    "fundName": "Vanguard U.S. Multifactor ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.61%",
    "marketValue": "$1.01M",
    "rawAllocation": 0.0061,
    "rawMarketValue": 1010000
  },
  {
    "ticker": "SPXL",
    "fundName": "Direxion Daily S&P 500 Bull 3X Shares",
    "segment": "Leveraged Equity: U.S.  -  Large Cap",
    "allocation": "0.60%",
    "marketValue": "$13.54M",
    "rawAllocation": 0.006,
    "rawMarketValue": 13540000
  },
  {
    "ticker": "IUS",
    "fundName": "Invesco RAFI Strategic US ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.58%",
    "marketValue": "$1.04M",
    "rawAllocation": 0.0058,
    "rawMarketValue": 1040000
  },
  {
    "ticker": "XT",
    "fundName": "iShares Exponential Technologies ETF",
    "segment": "Equity: Global Information Technology",
    "allocation": "0.58%",
    "marketValue": "$18.03M",
    "rawAllocation": 0.0058,
    "rawMarketValue": 18030000
  },
  {
    "ticker": "GSLC",
    "fundName": "Goldman Sachs ActiveBeta U.S. Large Cap Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.58%",
    "marketValue": "$62.48M",
    "rawAllocation": 0.0058,
    "rawMarketValue": 62480000
  },
  {
    "ticker": "PLRG",
    "fundName": "Principal U.S. Large-Cap Adaptive Multi-Factor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.56%",
    "marketValue": "$34.08K",
    "rawAllocation": 0.0056,
    "rawMarketValue": 34080
  },
  {
    "ticker": "JHML",
    "fundName": "John Hancock Multifactor Large Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.56%",
    "marketValue": "$4.01M",
    "rawAllocation": 0.0056,
    "rawMarketValue": 4010000
  },
  {
    "ticker": "NTSX",
    "fundName": "WisdomTree U.S. Efficient Core Fund",
    "segment": "Asset Allocation: U.S. Target Outcome",
    "allocation": "0.56%",
    "marketValue": "$4.37M",
    "rawAllocation": 0.0056,
    "rawMarketValue": 4370000
  },
  {
    "ticker": "METV",
    "fundName": "Roundhill Ball Metaverse ETF",
    "segment": "Equity: Global Internet",
    "allocation": "0.55%",
    "marketValue": "$2.41M",
    "rawAllocation": 0.0055,
    "rawMarketValue": 2410000
  },
  {
    "ticker": "WRND",
    "fundName": "IQ Global Equity R&D Leaders ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.55%",
    "marketValue": "$28.40K",
    "rawAllocation": 0.0055,
    "rawMarketValue": 28400
  },
  {
    "ticker": "ANEW",
    "fundName": "ProShares MSCI Transformational Changes ETF",
    "segment": "Equity: Global Broad Thematic",
    "allocation": "0.54%",
    "marketValue": "$55.54K",
    "rawAllocation": 0.0054,
    "rawMarketValue": 55540
  },
  {
    "ticker": "QWLD",
    "fundName": "SPDR MSCI World StrategicFactors ETF",
    "segment": "Equity: Developed Markets - Total Market",
    "allocation": "0.53%",
    "marketValue": "$428.55K",
    "rawAllocation": 0.0053,
    "rawMarketValue": 428550
  },
  {
    "ticker": "VCAR",
    "fundName": "Simplify Volt RoboCar Disruption and Tech ETF",
    "segment": "Equity: Global Mobility",
    "allocation": "0.53%",
    "marketValue": "$16.41K",
    "rawAllocation": 0.0053,
    "rawMarketValue": 16410
  },
  {
    "ticker": "RAFE",
    "fundName": "PIMCO RAFI ESG U.S. ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.52%",
    "marketValue": "$162.21K",
    "rawAllocation": 0.0052,
    "rawMarketValue": 162210
  },
  {
    "ticker": "GINN",
    "fundName": "Goldman Sachs Innovate Equity ETF",
    "segment": "Equity: Global Broad Thematic",
    "allocation": "0.52%",
    "marketValue": "$1.64M",
    "rawAllocation": 0.0052,
    "rawMarketValue": 1640000
  },
  {
    "ticker": "KOKU",
    "fundName": "Xtrackers MSCI Kokusai Equity ETF",
    "segment": "Equity: Developed Markets Ex-Japan  -  Total Market",
    "allocation": "0.52%",
    "marketValue": "$2.77M",
    "rawAllocation": 0.0052,
    "rawMarketValue": 2770000
  },
  {
    "ticker": "TOK",
    "fundName": "iShares MSCI Kokusai ETF",
    "segment": "Equity: Developed Markets Ex-Japan  -  Total Market",
    "allocation": "0.51%",
    "marketValue": "$950.05K",
    "rawAllocation": 0.0051,
    "rawMarketValue": 950050
  },
  {
    "ticker": "SPGM",
    "fundName": "SPDR Portfolio MSCI Global Stock Market ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.49%",
    "marketValue": "$2.70M",
    "rawAllocation": 0.0049,
    "rawMarketValue": 2700000
  },
  {
    "ticker": "LGH",
    "fundName": "HCM Defender 500 Index ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.49%",
    "marketValue": "$1.21M",
    "rawAllocation": 0.0049,
    "rawMarketValue": 1210000
  },
  {
    "ticker": "ESGU",
    "fundName": "iShares ESG Aware MSCI USA ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.48%",
    "marketValue": "$64.52M",
    "rawAllocation": 0.0048,
    "rawMarketValue": 64520000
  },
  {
    "ticker": "URTH",
    "fundName": "iShares MSCI World ETF",
    "segment": "Equity: Developed Markets - Total Market",
    "allocation": "0.48%",
    "marketValue": "$12.41M",
    "rawAllocation": 0.0048,
    "rawMarketValue": 12410000
  },
  {
    "ticker": "JCTR",
    "fundName": "JPMorgan Carbon Transition U.S. Equity ETF",
    "segment": "Equity: U.S. Low Carbon",
    "allocation": "0.46%",
    "marketValue": "$102.88K",
    "rawAllocation": 0.0046,
    "rawMarketValue": 102880
  },
  {
    "ticker": "OUSA",
    "fundName": "ALPS O'Shares U.S. Quality Dividend ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.46%",
    "marketValue": "$3.09M",
    "rawAllocation": 0.0046,
    "rawMarketValue": 3090000
  },
  {
    "ticker": "MFUS",
    "fundName": "PIMCO RAFI Dynamic Multi-Factor U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.46%",
    "marketValue": "$573.08K",
    "rawAllocation": 0.0046,
    "rawMarketValue": 573080
  },
  {
    "ticker": "CRBN",
    "fundName": "iShares MSCI ACWI Low Carbon Target ETF",
    "segment": "Equity: Global Low Carbon",
    "allocation": "0.46%",
    "marketValue": "$4.06M",
    "rawAllocation": 0.0046,
    "rawMarketValue": 4060000
  },
  {
    "ticker": "FEX",
    "fundName": "First Trust Large Cap Core AlphaDEX Fund",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.45%",
    "marketValue": "$4.73M",
    "rawAllocation": 0.0045,
    "rawMarketValue": 4730000
  },
  {
    "ticker": "FNDX",
    "fundName": "Schwab Fundamental U.S. Large Company Index ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.44%",
    "marketValue": "$47.15M",
    "rawAllocation": 0.0044,
    "rawMarketValue": 47150000
  },
  {
    "ticker": "AVSU",
    "fundName": "Avantis Responsible U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.44%",
    "marketValue": "$631.15K",
    "rawAllocation": 0.0044,
    "rawMarketValue": 631150
  },
  {
    "ticker": "PRF",
    "fundName": "Invesco FTSE RAFI U.S. 1000 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.44%",
    "marketValue": "$25.30M",
    "rawAllocation": 0.0044,
    "rawMarketValue": 25300000
  },
  {
    "ticker": "ACWI",
    "fundName": "iShares MSCI ACWI ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.43%",
    "marketValue": "$74.69M",
    "rawAllocation": 0.0043,
    "rawMarketValue": 74690000
  },
  {
    "ticker": "JPUS",
    "fundName": "JPMorgan Diversified Return U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.41%",
    "marketValue": "$2.01M",
    "rawAllocation": 0.0041,
    "rawMarketValue": 2010000
  },
  {
    "ticker": "FNDB",
    "fundName": "Schwab Fundamental U.S. Broad Market Index ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.41%",
    "marketValue": "$2.01M",
    "rawAllocation": 0.0041,
    "rawMarketValue": 2010000
  },
  {
    "ticker": "USMV",
    "fundName": "iShares MSCI USA Min Vol Factor ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.39%",
    "marketValue": "$113.30M",
    "rawAllocation": 0.0039,
    "rawMarketValue": 113300000
  },
  {
    "ticker": "VLU",
    "fundName": "SPDR S&P 1500 Value Tilt ETF",
    "segment": "Equity: U.S.  -  Total Market Value",
    "allocation": "0.38%",
    "marketValue": "$853.95K",
    "rawAllocation": 0.0038,
    "rawMarketValue": 853950
  },
  {
    "ticker": "VT",
    "fundName": "Vanguard Total World Stock ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.37%",
    "marketValue": "$96.79M",
    "rawAllocation": 0.0037,
    "rawMarketValue": 96790000
  },
  {
    "ticker": "ERM",
    "fundName": "EquityCompass Risk Manager ETF",
    "segment": "Asset Allocation: U.S. Target Outcome",
    "allocation": "0.37%",
    "marketValue": "$59.33K",
    "rawAllocation": 0.0037,
    "rawMarketValue": 59330
  },
  {
    "ticker": "FAD",
    "fundName": "First Trust Multi Cap Growth AlphaDEX Fund",
    "segment": "Equity: U.S. - Total Market Growth",
    "allocation": "0.36%",
    "marketValue": "$594.54K",
    "rawAllocation": 0.0036,
    "rawMarketValue": 594540
  },
  {
    "ticker": "FTLS",
    "fundName": "First Trust Long/Short Equity ETF",
    "segment": "Alternatives: Hedge Fund Strategies",
    "allocation": "0.36%",
    "marketValue": "$2.58M",
    "rawAllocation": 0.0036,
    "rawMarketValue": 2580000
  },
  {
    "ticker": "NZAC",
    "fundName": "SPDR MSCI ACWI Climate Paris Aligned ETF",
    "segment": "Equity: Global Low Carbon",
    "allocation": "0.36%",
    "marketValue": "$854.26K",
    "rawAllocation": 0.0036,
    "rawMarketValue": 854260
  },
  {
    "ticker": "AVUS",
    "fundName": "Avantis U.S. Equity ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.36%",
    "marketValue": "$14.26M",
    "rawAllocation": 0.0036,
    "rawMarketValue": 14260000
  },
  {
    "ticker": "KRUZ",
    "fundName": "Unusual Whales Subversive Republican Trading ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.35%",
    "marketValue": "$16.41K",
    "rawAllocation": 0.0035,
    "rawMarketValue": 16410
  },
  {
    "ticker": "TPLE",
    "fundName": "Timothy Plan US Large / Mid Cap Core Enhanced ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.34%",
    "marketValue": "$210.80K",
    "rawAllocation": 0.0034,
    "rawMarketValue": 210800
  },
  {
    "ticker": "TPLC",
    "fundName": "Timothy Plan US Large / Mid Cap Core ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.34%",
    "marketValue": "$642.51K",
    "rawAllocation": 0.0034,
    "rawMarketValue": 642510
  },
  {
    "ticker": "QRFT",
    "fundName": "QRAFT AI-Enhanced U.S. Large Cap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.34%",
    "marketValue": "$16.41K",
    "rawAllocation": 0.0034,
    "rawMarketValue": 16410
  },
  {
    "ticker": "DEIF",
    "fundName": "Sterling Capital Diverse Multi-Manager Active ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.32%",
    "marketValue": "$295.38K",
    "rawAllocation": 0.0032,
    "rawMarketValue": 295380
  },
  {
    "ticker": "GLOV",
    "fundName": "Goldman Sachs ActiveBeta World Low Vol Plus Equity ETF",
    "segment": "Equity: Developed Markets - Total Market",
    "allocation": "0.27%",
    "marketValue": "$1.87M",
    "rawAllocation": 0.0027,
    "rawMarketValue": 1870000
  },
  {
    "ticker": "BFOR",
    "fundName": "ALPS Barron's 400 ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.26%",
    "marketValue": "$324.41K",
    "rawAllocation": 0.0026,
    "rawMarketValue": 324410
  },
  {
    "ticker": "GLOF",
    "fundName": "iShares Global Equity Factor ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.26%",
    "marketValue": "$303.79K",
    "rawAllocation": 0.0026,
    "rawMarketValue": 303790
  },
  {
    "ticker": "TPMN",
    "fundName": "Timothy Plan Market Neutral ETF",
    "segment": "Alternatives: Hedge Fund Strategies",
    "allocation": "0.25%",
    "marketValue": "$145.80K",
    "rawAllocation": 0.0025,
    "rawMarketValue": 145800
  },
  {
    "ticker": "BLES",
    "fundName": "Inspire Global Hope ETF",
    "segment": "Equity: Global  -  Large Cap",
    "allocation": "0.25%",
    "marketValue": "$369.22K",
    "rawAllocation": 0.0025,
    "rawMarketValue": 369220
  },
  {
    "ticker": "FCTR",
    "fundName": "First Trust Lunt U.S. Factor Rotation ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.25%",
    "marketValue": "$446.85K",
    "rawAllocation": 0.0025,
    "rawMarketValue": 446850
  },
  {
    "ticker": "SSPY",
    "fundName": "Syntax Stratified LargeCap ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.23%",
    "marketValue": "$222.16K",
    "rawAllocation": 0.0023,
    "rawMarketValue": 222160
  },
  {
    "ticker": "JUSA",
    "fundName": "JPMorgan ActiveBuilders U.S. Large Cap Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.23%",
    "marketValue": "$58.70K",
    "rawAllocation": 0.0023,
    "rawMarketValue": 58700
  },
  {
    "ticker": "RWL",
    "fundName": "Invesco S&P 500 Revenue ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.22%",
    "marketValue": "$3.77M",
    "rawAllocation": 0.0022,
    "rawMarketValue": 3770000
  },
  {
    "ticker": "GSEW",
    "fundName": "Goldman Sachs Equal Weight U.S. Large Cap Equity ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.21%",
    "marketValue": "$930.95K",
    "rawAllocation": 0.0021,
    "rawMarketValue": 930950
  },
  {
    "ticker": "CFA",
    "fundName": "VictoryShares US 500 Volatility Wtd ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.20%",
    "marketValue": "$1.11M",
    "rawAllocation": 0.002,
    "rawMarketValue": 1110000
  },
  {
    "ticker": "CFO",
    "fundName": "VictoryShares U.S. 500 Enhanced Volatility Wtd Index ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.20%",
    "marketValue": "$1.48M",
    "rawAllocation": 0.002,
    "rawMarketValue": 1480000
  },
  {
    "ticker": "RSP",
    "fundName": "Invesco S&P 500 Equal Weight ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.20%",
    "marketValue": "$65.01M",
    "rawAllocation": 0.002,
    "rawMarketValue": 65010000
  },
  {
    "ticker": "JGRO",
    "fundName": "JPMorgan Active Growth ETF",
    "segment": "Equity: U.S.  -  Large Cap Growth",
    "allocation": "0.20%",
    "marketValue": "$527.64K",
    "rawAllocation": 0.002,
    "rawMarketValue": 527640
  },
  {
    "ticker": "FBCV",
    "fundName": "Fidelity Blue Chip Value ETF",
    "segment": "Equity: Global  - Large Cap Value",
    "allocation": "0.19%",
    "marketValue": "$250.20K",
    "rawAllocation": 0.0019,
    "rawMarketValue": 250200
  },
  {
    "ticker": "NZUS",
    "fundName": "SPDR MSCI USA Climate Paris Aligned ETF",
    "segment": "Equity: U.S. Low Carbon",
    "allocation": "0.19%",
    "marketValue": "$180.51K",
    "rawAllocation": 0.0019,
    "rawMarketValue": 180510
  },
  {
    "ticker": "PABU",
    "fundName": "iShares Paris-Aligned Climate MSCI USA ETF",
    "segment": "Equity: U.S. Low Carbon",
    "allocation": "0.19%",
    "marketValue": "$2.36M",
    "rawAllocation": 0.0019,
    "rawMarketValue": 2360000
  },
  {
    "ticker": "VALQ",
    "fundName": "American Century STOXX U.S. Quality Value ETF",
    "segment": "Equity: U.S.  -  Total Market Value",
    "allocation": "0.18%",
    "marketValue": "$373.64K",
    "rawAllocation": 0.0018,
    "rawMarketValue": 373640
  },
  {
    "ticker": "SIZE",
    "fundName": "iShares MSCI USA Size Factor ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.18%",
    "marketValue": "$549.10K",
    "rawAllocation": 0.0018,
    "rawMarketValue": 549100
  },
  {
    "ticker": "EUSA",
    "fundName": "iShares MSCI U.S.A. Equal Weighted ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.18%",
    "marketValue": "$733.40K",
    "rawAllocation": 0.0018,
    "rawMarketValue": 733400
  },
  {
    "ticker": "OMFL",
    "fundName": "Invesco Russell 1000 Dynamic Multifactor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.18%",
    "marketValue": "$6.53M",
    "rawAllocation": 0.0018,
    "rawMarketValue": 6530000
  },
  {
    "ticker": "CPI",
    "fundName": "IQ Real Return ETF",
    "segment": "Alternatives: Hedge Fund Strategies",
    "allocation": "0.17%",
    "marketValue": "$10.73K",
    "rawAllocation": 0.0017,
    "rawMarketValue": 10730
  },
  {
    "ticker": "GVLU",
    "fundName": "Gotham 1000 Value ETF",
    "segment": "Equity: U.S.  -  Total Market Value",
    "allocation": "0.17%",
    "marketValue": "$228.48K",
    "rawAllocation": 0.0017,
    "rawMarketValue": 228480
  },
  {
    "ticker": "NANC",
    "fundName": "Unusual Whales Subversive Democratic Trading ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.15%",
    "marketValue": "$9.47K",
    "rawAllocation": 0.0015,
    "rawMarketValue": 9470
  },
  {
    "ticker": "HKND",
    "fundName": "Humankind U.S. Stock ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.14%",
    "marketValue": "$180.51K",
    "rawAllocation": 0.0014,
    "rawMarketValue": 180510
  },
  {
    "ticker": "KOMP",
    "fundName": "SPDR S&P Kensho New Economies Composite ETF",
    "segment": "Equity: Global Broad Thematic",
    "allocation": "0.11%",
    "marketValue": "$1.74M",
    "rawAllocation": 0.0011,
    "rawMarketValue": 1740000
  },
  {
    "ticker": "SQEW",
    "fundName": "LeaderShares Equity Skew ETF",
    "segment": "Equity: Global  -  Total Market",
    "allocation": "0.10%",
    "marketValue": "$129.39K",
    "rawAllocation": 0.001,
    "rawMarketValue": 129390
  },
  {
    "ticker": "EQAL",
    "fundName": "Invesco Russell 1000 Equal Weight ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.07%",
    "marketValue": "$377.43K",
    "rawAllocation": 0.0007,
    "rawMarketValue": 377430
  },
  {
    "ticker": "DEUS",
    "fundName": "Xtrackers Russell US Multifactor ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.06%",
    "marketValue": "$89.62K",
    "rawAllocation": 0.0006,
    "rawMarketValue": 89620
  },
  {
    "ticker": "ONEO",
    "fundName": "SPDR Russell 1000 Momentum Focus ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.06%",
    "marketValue": "$88.36K",
    "rawAllocation": 0.0006,
    "rawMarketValue": 88360
  },
  {
    "ticker": "VFMO",
    "fundName": "Vanguard U.S. Momentum Factor ETF",
    "segment": "Equity: U.S.  -  Total Market",
    "allocation": "0.05%",
    "marketValue": "$135.12K",
    "rawAllocation": 0.0005,
    "rawMarketValue": 135120
  },
  {
    "ticker": "YPS",
    "fundName": "Arrow Reverse Cap 500 ETF",
    "segment": "Equity: U.S.  -  Large Cap",
    "allocation": "0.04%",
    "marketValue": "$5.68K",
    "rawAllocation": 0.0004,
    "rawMarketValue": 5680
  },
  {
    "ticker": "EVNT",
    "fundName": "AltShares Event-Driven ETF",
    "segment": "Alternatives: Hedge Fund Strategies",
    "allocation": "-0.47%",
    "marketValue": "$-14,857.25",
    "rawAllocation": -0.0047,
    "rawMarketValue": -14857.25
  }
]`,
  },


  {
    id: 'econ/calendar',
    method: 'GET',
    url: `/econ/calendar`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

calendar = client.econ.calendar(
  from_date='2025-01-01',
  to_date='2025-01-31',
  country='US,AU',
  min_importance=0
)
print(calendar)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const calendar = await client.econ.calendar({
  from: '2025-01-01',
  to: '2025-01-31',
  country: 'US,AU',
  minImportance: 0
});
console.log(calendar);`,
      cURL: `curl -X GET "https://api.axionquant.com/econ/calendar?from=2025-01-01&to=2025-01-31&country=US,AU&minImportance=0" \
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
  {
    "id": "371582",
    "title": "S&P Global Australia Manufacturing PMI Final",
    "country": "australia",
    "indicator": "manufacturing pmi",
    "ticker": null,
    "comment": "The S&P Global Australia Manufacturing PMI is compiled by S&P Global from responses to monthly questionnaires sent to purchasing managers in a panel of around 400 manufacturers. The headline figure is the Purchasing Managers' Index (PMI), which is a weighted average of the following five indices: New Orders (30%), Output (25%), Employment (20%), Suppliers' Delivery Times (15%) and Stocks of Purchases (10%). For the PMI calculation the Suppliers' Delivery Times Index is inverted so that it moves in a comparable direction to the other indices. The index varies between 0 and 100, with a reading above 50 indicating an overall increase compared to the previous month, and below 50 an overall decrease. This is only a limited sample of PMI headline data displayed on the Customer's service, under licence from S&P Global. Full historic PMI headline data and all other PMI sub-index data and histories are available on subscription from S&P Global. Contact economics@spglobal.com for more details.",
    "category": "bsnss",
    "period": "Dec",
    "referenceDate": "2024-12-31T00:00:00.000Z",
    "source": "S&P Global",
    "sourceUrl": "https://www.pmi.spglobal.com/public",
    "actual": null,
    "previous": null,
    "forecast": "48.2",
    "actualRaw": null,
    "previousRaw": null,
    "forecastRaw": "48.2",
    "currency": "AUD",
    "importance": 0,
    "date": "2025-01-01T22:00:00.000Z"
  },
  {
    "id": "368875",
    "title": "MBA 30-Year Mortgage Rate",
    "country": "america",
    "indicator": "Mortgage Rate",
    "ticker": "ECONOMICS:USMR",
    "comment": "MBA 30-Year Mortgage Rate is average 30-year fixed mortgage lending rate measured during the reported week and backed by the Mortgage Bankers Association.",
    "category": "hse",
    "period": "Dec/27",
    "referenceDate": "2024-12-27T00:00:00.000Z",
    "source": "Mortgage Bankers Association of America",
    "sourceUrl": "http://www.mortgagebankers.org/",
    "actual": "6.97",
    "previous": "6.75",
    "forecast": null,
    "actualRaw": "6.97",
    "previousRaw": "6.75",
    "forecastRaw": null,
    "currency": "USD",
    "importance": 0,
    "date": "2025-01-02T12:00:00.000Z"
  },
  {
    "id": "368880",
    "title": "Initial Jobless Claims",
    "country": "america",
    "indicator": "Initial Jobless Claims",
    "ticker": "ECONOMICS:USIJC",
    "comment": "Initial jobless claims refer to the number of people who have filed for unemployment benefits with their state's unemployment agency for the first time during a specific reporting period, typically on a weekly basis. .",
    "category": "lbr",
    "period": "Dec/28",
    "referenceDate": "2024-12-28T00:00:00.000Z",
    "source": "Department of Labour",
    "sourceUrl": "https://www.dol.gov/",
    "actual": "211",
    "previous": "219",
    "forecast": "222",
    "actualRaw": "211000",
    "previousRaw": "219000",
    "forecastRaw": "222000",
    "currency": "USD",
    "importance": 0,
    "date": "2025-01-02T13:30:00.000Z"
  },
  {
    "id": "371615",
    "title": "S&P Global Manufacturing PMI Final",
    "country": "america",
    "indicator": "Manufacturing PMI",
    "ticker": null,
    "comment": "The S&P Global US Manufacturing PMI is compiled by S&P Global from responses to questionnaires sent to purchasing managers in a panel of around 800 manufacturers. The headline figure is the Purchasing Managers' Index (PMI), which is a weighted average of the following five indices: New Orders (30%), Output (25%), Employment (20%), Suppliers' Delivery Times (15%) and Stocks of Purchases (10%). For the PMI calculation the Suppliers' Delivery Times Index is inverted so that it moves in a comparable direction to the other indices. The index varies between 0 and 100, with a reading above 50 indicating an overall increase compared to the previous month, and below 50 an overall decrease. This is only a limited sample of PMI headline data displayed on the Customer's service, under licence from S&P Global. Full historic PMI headline data and all other PMI sub-index data and histories are available on subscription from S&P Global. Contact economics@spglobal.com for more details.",
    "category": "bsnss",
    "period": "Dec",
    "referenceDate": "2024-12-31T00:00:00.000Z",
    "source": "S&P Global",
    "sourceUrl": "https://www.pmi.spglobal.com/public",
    "actual": null,
    "previous": null,
    "forecast": "48.3",
    "actualRaw": null,
    "previousRaw": null,
    "forecastRaw": "48.3",
    "currency": "USD",
    "importance": 0,
    "date": "2025-01-02T14:45:00.000Z"
  },
  {
    "id": "368889",
    "title": "EIA Gasoline Stocks Change",
    "country": "america",
    "indicator": "Gasoline Stocks Change",
    "ticker": "ECONOMICS:USGSCH",
    "comment": "Stocks of gasoline refers to the weekly change of the gasoline supply situation.",
    "category": null,
    "period": "Dec/27",
    "referenceDate": "2024-12-27T00:00:00.000Z",
    "source": "U.S. Energy Information Administration",
    "sourceUrl": "http://www.eia.gov",
    "actual": "7.717",
    "previous": "1.63",
    "forecast": "0.7",
    "actualRaw": "7717000",
    "previousRaw": "1630000",
    "forecastRaw": "700000",
    "currency": "USD",
    "importance": 0,
    "date": "2025-01-02T16:00:00.000Z"
  },
  {
    "id": "368895",
    "title": "EIA Crude Oil Stocks Change",
    "country": "america",
    "indicator": "Crude Oil Stocks Change",
    "ticker": "ECONOMICS:USCOSC",
    "comment": "Stocks of crude oil refer to the weekly change of the crude oil supply situation.",
    "category": null,
    "period": "Dec/27",
    "referenceDate": "2024-12-27T00:00:00.000Z",
    "source": "U.S. Energy Information Administration",
    "sourceUrl": "https://www.eia.gov",
    "actual": "-1.178",
    "previous": "-4.237",
    "forecast": "-2.75",
    "actualRaw": "-1178000",
    "previousRaw": "-4237000",
    "forecastRaw": "-2750000",
    "currency": "USD",
    "importance": 0,
    "date": "2025-01-02T16:00:00.000Z"
  }
]`,
  },

  // FINANCIALS
  {
    id: 'financials/ticker/snapshot',
    method: 'GET',
    url: `/financials/WMT/snapshot`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

snapshot = client.financials.snapshot('WMT')
print(snapshot)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const snapshot = await client.financials.snapshot('WMT');
console.log(snapshot);`,
      cURL: `curl -X GET "https://api.axionquant.com/financials/AAPL/snapshot" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `{
  "currentPrice": 114.83,
  "targetHighPrice": 136,
  "targetLowPrice": 62,
  "targetMeanPrice": 120.13158,
  "targetMedianPrice": 121,
  "recommendationMean": 1.36585,
  "recommendationKey": "strong_buy",
  "numberOfAnalystOpinions": 38,
  "totalCash": 10581999616,
  "totalCashPerShare": 1.328,
  "ebitda": 42713001984,
  "totalDebt": 68423999488,
  "quickRatio": 0.196,
  "currentRatio": 0.803,
  "totalRevenue": 703060967424,
  "debtToEquity": 66.747,
  "revenuePerShare": 87.902,
  "returnOnAssets": 0.06539,
  "returnOnEquity": 0.23661,
  "grossProfits": 175108997120,
  "freeCashflow": 10372750336,
  "operatingCashflow": 40976998400,
  "earningsGrowth": 0.352,
  "revenueGrowth": 0.058,
  "grossMargins": 0.24906999,
  "ebitdaMargins": 0.060749996,
  "operatingMargins": 0.0373,
  "profitMargins": 0.03259,
  "financialCurrency": "USD"
}`,
  },

  // ECON DATASET
  {
    id: 'econ/dataset',
    method: 'GET',
    url: `/econ/search`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

# First search for the dataset to get its ID
results = client.econ.search('Mortgage Rates')
dataset_id = results[0]['id']

# Then pull the full dataset using that ID
dataset = client.econ.dataset(dataset_id)
print(dataset)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

// First search for the dataset to get its ID
const results = await client.econ.search('Mortgage Rates');
const datasetId = results[0].id;

// Then pull the full dataset using that ID
const dataset = await client.econ.dataset(datasetId);
console.log(dataset);`,
      cURL: `# First search for the dataset to get its ID
curl -X GET "https://api.axionquant.com/econ/search?query=Mortgage%20Rates" \\
  -H "Authorization: Bearer axn_123"

# Then pull the full dataset using the returned ID
curl -X GET "https://api.axionquant.com/econ/dataset/MORTGAGE30US" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
  {
    "realtimeStart": "2013-12-19T00:00:00.000Z",
    "date": "1971-04-02T00:00:00.000Z",
    "value": 7.33
  },
  {
    "realtimeStart": "2013-12-19T00:00:00.000Z",
    "date": "1971-04-09T00:00:00.000Z",
    "value": 7.31
  },
  {
    "realtimeStart": "2013-12-19T00:00:00.000Z",
    "date": "1971-04-16T00:00:00.000Z",
    "value": 7.31
  },
  {
    "realtimeStart": "2013-12-19T00:00:00.000Z",
    "date": "1971-04-23T00:00:00.000Z",
    "value": 7.31
  },
  {
    "realtimeStart": "2013-12-19T00:00:00.000Z",
    "date": "1971-04-30T00:00:00.000Z",
    "value": 7.29
  },
...
  {
    "realtimeStart": "2026-04-16T00:00:00.000Z",
    "date": "2026-04-16T00:00:00.000Z",
    "value": 6.3
  },
  {
    "realtimeStart": "2026-04-23T00:00:00.000Z",
    "date": "2026-04-23T00:00:00.000Z",
    "value": 6.23
  },
  {
    "realtimeStart": "2026-04-30T00:00:00.000Z",
    "date": "2026-04-30T00:00:00.000Z",
    "value": 6.3
  },
  {
    "realtimeStart": "2026-05-07T00:00:00.000Z",
    "date": "2026-05-07T00:00:00.000Z",
    "value": 6.37
  }
]`,
  },

  // ESG
  {
    id: 'esg/ticker',
    method: 'GET',
    url: `/esg/JPM`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

esg_data = client.esg.data('JPM')
print(esg_data)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const esgData = await client.esg.data('JPM');
console.log(esgData);`,
      cURL: `curl -X GET "https://api.axionquant.com/esg/JPM" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
  {
    "category": "esg",
    "score": 71.43,
    "grade": "A",
    "id": "1"
  },
  {
    "category": "social",
    "score": 43.5,
    "grade": "BBB",
    "id": "5"
  },
  {
    "category": "governance",
    "score": 47.7,
    "grade": "BBB",
    "id": "6"
  },
  {
    "category": "controversy",
    "score": 10,
    "grade": "CCC",
    "id": "3"
  },
  {
    "category": "environment",
    "score": 84.8,
    "grade": "AA",
    "id": "4"
  }
]`,
  },

  // SUPPLY CHAIN
  {
    id: 'supplychain/customers',
    method: 'GET',
    url: `/supply-chain/TSM/customers`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

customers = client.supply_chain.customers('TSM')
print(customers)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const customers = await client.supplyChain.customers('TSM');
console.log(customers);`,
      cURL: `curl -X GET "https://api.axionquant.com/supply-chain/TSM/customers" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
    {
        "ticker": "NVDA",
        "companyName": "Nvidia Corp",
        "marketCap": "4,978,690.92",
        "revenues": "253,491.00",
        "income": "159,613.00",
        "employees": "42,000"
    },
    {
        "ticker": "AAPL",
        "companyName": "Apple Inc",
        "marketCap": "4,614,941.34",
        "revenues": "451,442.00",
        "income": "122,575.00",
        "employees": "166,000"
    },
    {
        "ticker": "AVGO",
        "companyName": "Broadcom Inc",
        "marketCap": "1,894,609.37",
        "revenues": "75,465.00",
        "income": "29,317.00",
        "employees": "33,000"
    },
    {
        "ticker": "MU",
        "companyName": "Micron Technology Inc",
        "marketCap": "1,086,376.00",
        "revenues": "90,274.00",
        "income": "50,469.00",
        "employees": "53,000"
    },
    {
        "ticker": "AMD",
        "companyName": "Advanced Micro Devices Inc",
        "marketCap": "853,718.25",
        "revenues": "36,413.00",
        "income": "5,009.00",
        "employees": "31,000"
    },
    {
        "ticker": "ASML",
        "companyName": "Asml Holding Nv",
        "marketCap": "687,827.99",
        "revenues": "36,586.96",
        "income": "10,762.53",
        "employees": "2,500"
    },
    {
        "ticker": "INTC",
        "companyName": "Intel Corporation",
        "marketCap": "560,349.92",
        "revenues": "53,763.00",
        "income": "-3,368.00",
        "employees": "85,100"
    },
    {
        "ticker": "AMAT",
        "companyName": "Applied Materials Inc",
        "marketCap": "455,829.50",
        "revenues": "29,024.00",
        "income": "8,508.00",
        "employees": "36,500"
    },
    {
        "ticker": "CSCO",
        "companyName": "Cisco Systems Inc",
        "marketCap": "453,231.24",
        "revenues": "60,746.00",
        "income": "11,958.00",
        "employees": "90,400"
    },
    {
        "ticker": "LRCX",
        "companyName": "Lam Research Corporation",
        "marketCap": "418,877.82",
        "revenues": "21,682.16",
        "income": "6,708.20",
        "employees": "17,450"
    }
]`,
  },

  // WEB TRAFFIC
  {
    id: 'stocks/traffic',
    method: 'GET',
    url: `/web-traffic/UBER/traffic`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

traffic = client.web_traffic.traffic('UBER')
print(traffic)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const traffic = await client.webTraffic.traffic('UBER');
console.log(traffic);`,
      cURL: `curl -X GET "https://api.axionquant.com/stocks/AAPL/traffic" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `{
  "global": [
    {
      "country": "United States",
      "contribution": "42.77%",
      "count": "35.87M",
      "desktopSplit": "16.28%",
      "mobileSplit": "83.72%"
    },
    {
      "country": "United Kingdom",
      "contribution": "9.39%",
      "count": "7.88M",
      "desktopSplit": "14.24%",
      "mobileSplit": "85.76%"
    },
    {
      "country": "India",
      "contribution": "6.97%",
      "count": "5.85M",
      "desktopSplit": "8.0%",
      "mobileSplit": "92.0%"
    },
    {
      "country": "Brazil",
      "contribution": "5.45%",
      "count": "4.57M",
      "desktopSplit": "24.74%",
      "mobileSplit": "75.26%"
    },
    {
      "country": "Australia",
      "contribution": "4.19%",
      "count": "3.52M",
      "desktopSplit": "25.64%",
      "mobileSplit": "74.36%"
    }
  ],
  "seo": {
    "organic": "20.86M",
    "paid": "337.58K",
    "keywords": [
      {
        "keyword": "uber",
        "position": "1",
        "volume": "1,500,000",
        "cpc": 0.57,
        "traffic": 20.06
      },
      {
        "keyword": "uber ride",
        "position": "1",
        "volume": "201,000",
        "cpc": 0.54,
        "traffic": 2.68
      },
      {
        "keyword": "uber customer service number",
        "position": "1",
        "volume": "110,000",
        "cpc": 1.54,
        "traffic": 1.47
      },
      {
        "keyword": "uber driver",
        "position": "1",
        "volume": "90,500",
        "cpc": 2.43,
        "traffic": 1.21
      },
      {
        "keyword": "uber eats customer service number",
        "position": "1",
        "volume": "90,500",
        "cpc": 2.19,
        "traffic": 1.21
      }
    ],
    "backlinks": {
      "authority": "87",
      "referringDomains": "144.79K",
      "backlinks": "21.87M"
    }
  },
  "site": "uber.com",
}`,
  },

  // CREDIT
  {
    id: 'credit/ratings',
    method: 'GET',
    url: `/credit/BRK.A/rating`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

# First search for the entity to get its ID
results = client.credit.search('Berkshire Hathaway Inc.')
entity_id = results[0]['id']

# Then pull ratings using that ID
ratings = client.credit.ratings(entity_id)
print(ratings)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

// First search for the entity to get its ID
const results = await client.credit.search('Berkshire Hathaway Inc.');
const entityId = results[0].id;

// Then pull ratings using that ID
const ratings = await client.credit.ratings(entityId);
console.log(ratings);`,
      cURL: `# First search for the entity to get its ID
curl -X GET "https://api.axionquant.com/credit/search?query=Berkshire%20Hathaway%20Inc." \\
  -H "Authorization: Bearer axn_123"

# Then pull ratings using the returned ID
curl -X GET "https://api.axionquant.com/credit/ratings/112354" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
  {
    "orgDebtTypeDesc": "Issuer Credit Rating",
    "rating": "AA",
    "ratingDate": "16-May-2013",
    "currentCwOl": "Stable",
    "currentCwOlDate": "22-Aug-2017",
    "ratingDebtTypeCode": "ICR",
    "lastReviewDate": "30-Oct-2025",
    "coreOrgId": "100264",
    "endorsementIndicator": "EE|UKE",
    "coreRatingId": "935739519",
    "ratingTypeCode": "STDLONG",
    "ratingTypeCodeDesc": "Local Currency LT",
    "pcrFlag": true,
    "id": 1
  },
  {
    "orgDebtTypeDesc": "Issuer Credit Rating",
    "rating": "A-1+",
    "ratingDate": "28-Oct-1997",
    "ratingDebtTypeCode": "ICR",
    "lastReviewDate": "30-Oct-2025",
    "coreOrgId": "100264",
    "endorsementIndicator": "EE|UKE",
    "coreRatingId": "935739524",
    "ratingTypeCode": "STDSHORT",
    "ratingTypeCodeDesc": "Local Currency ST",
    "pcrFlag": true,
    "id": 2
  },
  {
    "orgDebtTypeDesc": "Issuer Credit Rating",
    "rating": "AA",
    "ratingDate": "19-Feb-2016",
    "currentCwOl": "Stable",
    "currentCwOlDate": "22-Aug-2017",
    "ratingDebtTypeCode": "ICR",
    "lastReviewDate": "30-Oct-2025",
    "coreOrgId": "100264",
    "endorsementIndicator": "EE|UKE",
    "coreRatingId": "935739521",
    "ratingTypeCode": "FCLONG",
    "ratingTypeCodeDesc": "Foreign Currency LT",
    "pcrFlag": true,
    "id": 3
  },
  {
    "orgDebtTypeDesc": "Issuer Credit Rating",
    "rating": "A-1+",
    "ratingDate": "19-Feb-2016",
    "ratingDebtTypeCode": "ICR",
    "lastReviewDate": "30-Oct-2025",
    "coreOrgId": "100264",
    "endorsementIndicator": "EE|UKE",
    "coreRatingId": "935739523",
    "ratingTypeCode": "FCSHORT",
    "ratingTypeCodeDesc": "Foreign Currency ST",
    "pcrFlag": true,
    "id": 4
  }
]`,
  },

    {
    id: 'news/ticker',
    method: 'GET',
    url: `/news/AMD`,
    code: {
      Python: `from axion import Axion
client = Axion(api_key='axn_123')

news = client.news.company('AMD')
print(news)`,
      JavaScript: `const { Axion } = require('@axionquant/sdk');
const client = new Axion('axn_123');

const news = await client.news.company('AMD');
console.log(news);`,
      cURL: `curl -X GET "https://api.axionquant.com/news/AMD" \\
  -H "Authorization: Bearer axn_123"`,
    },
    response: `[
  {
    "title": "AMD: $600 Target Appears Too Low (NASDAQ:AMD) - Seeking Alpha",
    "link": "http://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWllMEZWWDNseFRFMVpaMDQwWnpNMVZEbHBNbE5CVGxOdVYyOXJhbTU2U0hsM0xXRlpaRFZEVlV4eU5GSlhaemhWVEhZeFpFWmFOVTVIV1ZkeFpqbDBhekpEVlZVdFRYZG1lVWRWU1hSb0xVSmFlVEF6VVRaV2MxQlRSVWRRYzNWWmJWbHNRazlRVUVOV1dFOTRYemhzYTBkb2NrRmZMVEZFYm5SaGN3P29jPTU",
    "summary": "AMD: $600 Target Appears Too Low (NASDAQ:AMD)  Seeking Alpha",
    "published": "Mon, 11 May 2026 00:00:00 GMT"
  },
  {
    "title": "Was Advanced Micro Devices (AMD) One of the Top "Blue Chip" Stocks Suddenly on Fire in April? - Yahoo Finance",
    "link": "http://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWlnZ0ZCVlY5NWNVeE5kVTk2YlV4cmFHa3RXbWR6TjJRd09IVlphell0T0RkM05sSmFYMnN6WW1SVWR6bHRRVGRpTTNWRmFtWjZVbU4zYkd0SlNYaFNaSEJtVDFGdE9URkxiSEIyV0V4T1RHWndRbXcxTW10eFdYcHdNMGR4WVZwd1RVRTBVVzFHZFMwM1QyNUtVVjh5VDI5M1JqWjNWbk01VkhCaWNVWjFRVzlxWlhOMz9vYz01",
    "summary": "Was Advanced Micro Devices (AMD) One of the Top "Blue Chip" Stocks Suddenly on Fire in April?  Yahoo Finance",
    "published": "Tue, 12 May 2026 21:29:19 GMT"
  },
  {
    "title": "Is It Too Late to Buy Advanced Micro Devices (AMD) Stock After Its 12-Month Gain of 320%? - The Motley Fool",
    "link": "http://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWlsZ0ZCVlY5NWNVeFFaVTVKWm5kUVp6ZG5WWGhQTjNSc1drUjVlbFZYTW1kTk9WbHdNMFo2VlVoMlJIVmxjRk5NV21wdVdXVlRNVTVXVlU5cmJGaEVWMnBaVDBWQ1dFcENSRTlWTFhORk4zaFlTbVJQWjJrM1prbExla3M1UzB3M2N6RnNRVEZXY0dReFRXOTNWblkzYTJGWFFXa3hlR1J6YWt0aGVUUk1VWEp2UWtoNmFuRlNhV0pzU0RkUFltbFlWMWt0U1dkUGFGRT9vYz01",
    "summary": "Is It Too Late to Buy Advanced Micro Devices (AMD) Stock After Its 12-Month Gain of 320%?  The Motley Fool",
    "published": "Sun, 10 May 2026 18:15:00 GMT"
  },
  {
    "title": "Here is Why Advanced Micro Devices (AMD) is Among the 9 Best American Semiconductor Stocks to Buy According to Analysts - Yahoo Finance",
    "link": "http://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWltd0ZCVlY5NWNVeFBNbTF0UkRreFYwRk1TVUYzWjBkT2VUbDZNVUo1Wlc1aWNVOVBSbFZaVkhoblUxSnRORGR0YW1abVptdEpSRkJwWkhkSWNsSlFNR3BOUzB0S05ETXdhbFJsUlhSRlFtTkJZbWg1VWs5VFRuQllhbXBpWHpkSlJqUXhVWE51UTNKRU1FVkZTRXQyWnpGZlpVSXRhVkJ0TVZaMFJFdEpNR3RaWmtsa2VrSk9WVGx0VlhaeVJITm5iV2hZWW1aSmJuRkdURlJUU1E_b2M9NQ",
    "summary": "Here is Why Advanced Micro Devices (AMD) is Among the 9 Best American Semiconductor Stocks to Buy According to Analysts  Yahoo Finance",
    "published": "Mon, 11 May 2026 14:38:13 GMT"
  },
  {
    "title": "AMD Surges Nearly 80% Since Rep. Gil Cisneros's Perfectly Timed Pre-Earnings Bet - Benzinga",
    "link": "http://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWl5d0ZCVlY5NWNVeE5PR1V6ZWxCcU9EbE1VelZ1VjNaV1YxbENiVlpHY25sdlRURTNRWFV5VjJ4UWRFaHllRzFHT1d4WWQzaFRTVUpQZGtVMFdFVm1SRlpNZDA1bFVVRkVVMWhYYmpCM2RFWm1ORTlIU2xKQmMyVjRjMUYyVDB4R2VuZHZVVEJEY1hVMk0yVktXVTB3WlZreFVEQm9jREE1Y25RNE5GcHJabTl6VUVOeWJVRTJkWEJ2YlRVMk1GZGFla1ZoWWxSTFltMHplVzFyTkdadk0xWkNNREI0VW5kbVNXSlFjVTV2VEhNNWVGOU9aMUEwWlcxVWNYQTFYMVl6YjBrMlRVNVpOVkk0V1RremF3P29jPTU",
    "summary": "AMD Surges Nearly 80% Since Rep. Gil Cisneros's Perfectly Timed Pre-Earnings Bet  Benzinga",
    "published": "Tue, 12 May 2026 07:54:46 GMT"
  },

 ...
]
`,
  },
  {
    id: 'seeAll',
    method: 'GET',
    url: `See All Endpoints`,
    code: {
      Python: ``,
      JavaScript: ``,
      cURL: ``,
    },
    response: `{}`,
  },
];

export default ENDPOINTS;
